if (document.body.classList.contains("fe-flow-jtpl")) {
  const Symbolcurrency = document.body.getAttribute('theme-currency');
  const EnableDescription = true;
  const EnableDiscount = false;
  const EnableTitle = true;
  const Enablepreselect = "";
  const currentCountry = Shopify.country ;
  var selectedlens = false;
  const productVendor = document.body.getAttribute('product-vendor');
  const EnablePromotion = true;
  let promotionZeiss = '';

document.addEventListener('LensAdvizor:prescriptionTypes:rendered', function () {

  hiddenInputText = `<input id="hiddenordernoteProperty" type="hidden" name='la-properties[Order Note]' value="">`;
  DeliveryInputText = `<input id="nextdayProperty" type="hidden" name='la-properties[Delivery]' value="Next Day Available">`;
    wrapper = document.querySelector('.la-prescription-modal-wrapper')
    wrapper.insertAdjacentHTML('beforeend', hiddenInputText);
    wrapper.insertAdjacentHTML('beforeend', DeliveryInputText);  

  if (document.querySelector('.la-custom-trust-bar')) return;
  const header = document.querySelector('.la-error-box');

  if (header) {
    let ship_country_html = ""
    if (currentCountry=="US") {
      ship_country_html = ' <div class="text-block la-label-description">Free Tracked Delivery</div>'
    }
    else if(currentCountry == "GB"){
      ship_country_html = ' <div class="text-block la-label-description">Free Tracked Delivery</div>'
    }

    header.insertAdjacentHTML('afterend', `
      <div class="la-custom-trust-bar">
      <!--
        <div class="la-custom-reviews ">
            <div class="stars" style="color:#00b67a;">★★★★★</div>
            <div><strong>Trustpilot 5-star by 10k happy shoppers</strong></div>
        </div>
        -->
        <div class="la-custom-reviews la-custom-text-block">
            <div class="text-block la-label-description">100% Authentic</div>
            ${ship_country_html}
            <div class="text-block la-label-description">24-Month Warranty</div>
            <div class="text-block la-label-description">Fitted by Opticians</div>
        </div>
      </div>
    `);
  }
  const progress = document.querySelector(
  ".la-prescription-modal-header .la-progress-bar .la-step-bar"
);

if (progress) {
  progress.innerHTML = `
    <ul class="la-steps-list">
      <li class="la-step-item is-active">
        <div class="la-step-item-bar">
          <div class="la-step-bar-inner"></div>
        </div>
      </li>
      <li class="la-step-item">
        <div class="la-step-item-bar">
          <div class="la-step-bar-inner"></div>
        </div>
      </li>
      <li class="la-step-item">
        <div class="la-step-item-bar">
          <div class="la-step-bar-inner"></div>
        </div>
      </li>
      <li class="la-step-item">
        <div class="la-step-item-bar">
          <div class="la-step-bar-inner"></div>
        </div>
      </li>
      <li class="la-step-item">
        <div class="la-step-item-bar">
          <div class="la-step-bar-inner"></div>
        </div>
      </li>
    </ul>
  `;
}
});
var Addon = false;
//*********************** Display the size under the product title start *******************************/ 
function productTitle(){
  const mainTitle = document.getElementById('la-footer-frame-title');
    const Ptitle = document.querySelector('.la-footer-text.la-footer-frame-variant-title');
        if (Ptitle) {
            const text = Ptitle.textContent.trim();
            const match = text.match(/\(([^()]*)\)\s*$/);

            if (match) {
                const variantText = match[1];
                const titleText = text.replace(/\(([^()]*)\)\s*$/, '').trim();
                mainTitle.innerHTML = `
                    <span class="product-title">${titleText}</span>
                    <span class="product-selected-variant">${variantText}</span>
                `;
            }
        }   
}
//*********************** Display the size under the product title end *******************************/ 

//*********************** Your Build summary and add step class start *******************************/ 
let currentStep = 0;
let summary = false;
let nextDay = true;
document.addEventListener('LensAdvizor:component:DidMount', function () {
setTimeout(() => {
  productTitle();
  const removeSpaceAfterCurrency = selector => {
            document.querySelectorAll(selector).forEach(el => {
              el.textContent = el.textContent.replace(/([£$€¥])\s+/g, '$1');
              });
            };

          removeSpaceAfterCurrency('.la-frame-price');
          removeSpaceAfterCurrency('.la-footer-addon-price');
          removeSpaceAfterCurrency('.la-subtotal-price');
          removeSpaceAfterCurrency('.la-label-price');
           var discount = false;
          if(discount == true){
            document.querySelectorAll(".la-label-price").forEach(function (el) {
              const text = el.textContent.trim();
              // console.log(text);
              // Match currency and price
              const match = text.match(/^(\D+)\s*([\d,.]+)/);
          
              // if (!match) return;
              if (match){

              const currency = match[1].trim();
              const originalPrice = parseFloat(match[2].replace(/,/g, ""));
              
              if(originalPrice > 0){
                if (isNaN(originalPrice)) return;
                
                const discount = `25`;
                const discountedPrice = (originalPrice * (100 - discount) / 100).toFixed(2);
            
                el.innerHTML = `
                  <div class="price-box price-discount">
                  <div class="price-row">
                  <span class="old-price">${currency}${originalPrice.toFixed(2)}</span>
                  <span class="new-price">${currency}${discountedPrice}</span>
                  </div>
                  <div class="offer-text">
                      <p>25% off with LENSES25</p>
                  </div>
                  </div>
                `;
              } else{
                el.innerHTML = `
                  <div class="price-box applied-discount">
                    <div class="offer-text applied-text">Included</div>
                  </div>
                `;
              }
            } else{
              el.innerHTML = `
                  <div class="price-box applied-discount">
                    <div class="offer-text applied-text">Included</div>
                  </div>
                `;
            }
            });
          }
}, 10);
const removeSpaceAfterCurrency = selector => {
            document.querySelectorAll(selector).forEach(el => {
              el.textContent = el.textContent.replace(/([£$€¥])\s+/g, '$1');
              });
            };

          removeSpaceAfterCurrency('.la-frame-price');
          removeSpaceAfterCurrency('.la-footer-addon-price');
          removeSpaceAfterCurrency('.la-subtotal-price');
          removeSpaceAfterCurrency('.la-label-price');

    const wrapper = document.querySelector('.la-prescription-modal-content');
    if (!wrapper) return;
      currentStep++;
      updateStepClass(wrapper);
    if(summary == false){
      
    if(window.outerWidth <= 767){
      var productImage = document.querySelector('.la-subtotal-modal-trigger').innerHTML;
    }
      summary = true;
        document.querySelector('.la-boxy-layout-modal').insertAdjacentHTML(
          'afterbegin',
          `
           ${
              productImage
                ? `<div class="summary-product-info">
                    ${productImage}
                  </div>`
                : ''
            }
          <div class="la-footer-row-wrapper jtpl-cart-summary">
              <h3 class="la-translate">Your Build</h3>
                  <div class="la-footer-row summary-prescription-wrapper prescription-value-1 hide-prescription">
                      <div class="la-footer-text summary-prescription-heading la-translate la-footer-frame-prescription prescription-heading-1">Used For</div>
                      <div class="la-footer-text summary-prescription-title la-translate la-footer-frame-prescription value-option value1">—</div>
                  </div>
                  <div class="la-footer-row summary-prescription-wrapper prescription-value-2 hide-prescription">
                      <div class="la-footer-text summary-prescription-heading la-translate la-footer-frame-prescription prescription-heading-2">Method</div>
                      <div class="la-footer-text summary-prescription-title la-translate la-footer-frame-prescription value-option value2">—</div>
                  </div>
                  <div class="la-footer-row summary-prescription-wrapper prescription-value-3 hide-prescription">
                      <div class="la-footer-text summary-prescription-heading la-translate la-footer-frame-prescription prescription-heading-3">Lens type</div>
                      <div class="la-footer-text summary-prescription-title la-translate la-footer-frame-prescription value-option value3">—</div>
                  </div>
                  <div class="la-footer-row summary-prescription-wrapper prescription-value-4 hide-prescription">
                      <div class="la-footer-text summary-prescription-heading la-translate la-footer-frame-prescription prescription-heading-4">Lens</div>
                      <div class="la-footer-text summary-prescription-title la-translate la-footer-frame-prescription value-option value4">—</div>
                  </div>
                  <div class="la-footer-row summary-prescription-wrapper prescription-value-5 hide-prescription">
                      <div class="la-footer-text summary-prescription-heading la-translate la-footer-frame-prescription prescription-heading-5">Thickness</div>
                      <div class="la-footer-text summary-prescription-title la-translate la-footer-frame-prescription value-option value5">—</div>
                  </div>
                  <div class="la-footer-row summary-prescription-wrapper prescription-value-6 hide-prescription">
                      <div class="la-footer-text summary-prescription-heading la-translate la-footer-frame-prescription prescription-heading-6">Color</div>
                      <div class="la-footer-text summary-prescription-title la-translate la-footer-frame-prescription value-option value6">—</div>
                  </div>
                  <div class="la-footer-row summary-prescription-wrapper prescription-value-7 hide-prescription">
                      <div class="la-footer-text summary-prescription-heading la-translate la-footer-frame-prescription prescription-heading-7">Coating</div>
                      <div class="la-footer-text summary-prescription-title la-translate la-footer-frame-prescription value-option value7">—</div>
                  </div>
                  <div class="la-footer-row summary-prescription-wrapper prescription-value-8 hide-prescription">
                      <div class="la-footer-text summary-prescription-heading la-translate la-footer-frame-prescription prescription-heading-8">Add-on</div>
                      <div class="la-footer-text summary-prescription-title la-translate la-footer-frame-prescription value-option value8">—</div>
                  </div>
                  <div class="la-footer-row summary-prescription-wrapper prescription-value-9 hide-prescription">
                      <div class="la-footer-text summary-prescription-heading la-translate la-footer-frame-prescription prescription-heading-9">Dispatch Time</div>
                      <div class="la-footer-text summary-prescription-title la-translate la-footer-frame-prescription value-option value9" style="color: #1f7a4d !important;">Next Day Available</div>
                  </div>
                  <div class="discount-summary-cart hide-summary">
                    <div class="summary-discount-inner"><p>🏷 <strong>LENSES25</strong> · 25% off lenses</p> <span class="discount-ammount"></span></div>
                  </div>
          </div>
          
          ` 
      );
            }

      setTimeout(function(){

        document.querySelectorAll("label.la-label-btn").forEach(label => {
            const contentBox = label.querySelector(".la-label-content-box");
            const priceBox = label.querySelector(".la-label-price");

            if (contentBox && priceBox) {
                const wrapper = document.createElement("div");
                wrapper.className = "la-label-content-wrapper";
                contentBox.before(wrapper);
                wrapper.appendChild(contentBox);
                wrapper.appendChild(priceBox);
            }
        });



     //    document.querySelectorAll('.la-footer-row-wrapper.jtpl-cart-summary .la-footer-row la-subtotal').insertAdjacentHTML('afterbegin',`<div class="prescription-dispatch-message">Next-day delivery available on most lenses (order by 3pm). Varifocals and stronger prescriptions are made to order 7-10 working days. </div>`);
      var discount = false;
        if(discount == true){
          document.querySelectorAll('.la-footer-row').forEach(function (row) {

            const symbolEl = row.querySelector('.currency-symbol');
            const priceEl = row.querySelector('.la-footer-lens-price');

            if (!symbolEl || !priceEl) return; // Element nahi mila to skip

            const symbol = symbolEl.textContent.trim();
            const price = parseFloat(priceEl.textContent.trim());

            if (isNaN(price)) return;

            const discount = `25`;
            const discountedPrice = (price * (100 - discount) / 100).toFixed(2);

            var disamount = price.toFixed(2) - discountedPrice;
            document.querySelector(".discount-ammount").textContent = `- ${symbol}${disamount.toFixed(2)}`;
            document.querySelector(".discount-ammount").setAttribute("data-price", disamount.toFixed(2));

            const parentLabel = document.querySelector(".la-choose-prescription-wrapper");
            if (parentLabel && parentLabel.classList.contains("la-render-review")) {
                document.querySelector(".lens-discount-price").textContent = `- ${symbol}${disamount.toFixed(2)}`;
            }

            priceEl.innerHTML = `
              <div class="lenses-discount-price">
                <span class="old-price">
                    ${symbol}${price.toFixed(2)}
                </span>
                <span class="final-price">
                    ${symbol}${discountedPrice}
                </span>
              </div>
            `;
          }); 

          if(Addon == true){
            // const addonPriceEl = document.querySelector(".la-footer-addon-price");
            // const Priceaddon = document.querySelector(".la-footer-addon-price").textContent;
            // const currencySymbol = document.body.getAttribute('theme-currency');

            // if (addonPriceEl) {
            //     let addonPrice = parseFloat(
            //         addonPriceEl.textContent.replace(/[^\d.]/g, "")
            //     );
                
            //     const discountt = Number(`25`);
            //     let finalPrice = addonPrice - (addonPrice * (discountt / 100));
            //     if(finalPrice > 0){
            //       addonPriceEl.innerHTML = `
            //       <div class="lenses-discount-price">
            //         <span class="old-price">
            //             ${Priceaddon}
            //         </span>
            //         <span class="final-price">
            //             ${currencySymbol}${finalPrice.toFixed(2)}
            //         </span>
            //       </div>
            //       `;
            //     }
            // }
            const addonPriceEl = document.querySelectorAll(".la-footer-addon-price");
            addonPriceEl.forEach(function (addonPriceEl) {
            const discountAmountEl = document.querySelector(".discount-ammount");
            if(addonPriceEl){
              const Priceaddon = addonPriceEl.textContent;
              const currencySymbol = document.body.getAttribute("theme-currency");

              if (addonPriceEl) {
                  let addonPrice = parseFloat(
                      addonPriceEl.textContent.replace(/[^\d.]/g, "")
                  );

                  const discountt = Number(`25`);

                  let finalPrice = addonPrice - (addonPrice * (discountt / 100));

                  if (finalPrice > 0) {

                      // Addon discount
                      const addonDiscount = addonPrice - finalPrice;

                      // Existing discount amount (-£114.00)
                      if (discountAmountEl) {
                          let existingDiscount = parseFloat(
                              discountAmountEl.textContent.replace(/[^\d.]/g, "")
                          );

                          let totalDiscount = existingDiscount + addonDiscount;

                          discountAmountEl.textContent = `- ${currencySymbol}${totalDiscount.toFixed(2)}`;
                          discountAmountEl.setAttribute("data-price", totalDiscount.toFixed(2));

                          const parentLabel = document.querySelector(".la-choose-prescription-wrapper");
                          if (parentLabel && parentLabel.classList.contains("la-render-review")) {
                              document.querySelector(".lens-discount-price").textContent = `- ${currencySymbol}${totalDiscount.toFixed(2)}`;
                          }

                      }

                      addonPriceEl.innerHTML = `
                          <div class="lenses-discount-price">
                              <span class="old-price">
                                  ${Priceaddon}
                              </span>
                              <span class="final-price">
                                  ${currencySymbol}${finalPrice.toFixed(2)}
                              </span>
                          </div>
                      `;
                  }
              }
            }

          });



          }
          var SubtotalPrice = '';
          document.querySelectorAll(".la-subtotal-price").forEach((priceEl) => {
              let price = parseFloat(
                  priceEl.textContent.replace(/[^\d.]/g, "")
              );
              let discountEl = document.querySelector(".discount-ammount");
              if (discountEl && discountEl.textContent.trim() !== "") {
                  let discount = parseFloat(
                      discountEl.textContent.replace(/[^\d.]/g, "")
                  );
                  let finalPrice = price - discount;
                  priceEl.textContent = `${Symbolcurrency}${finalPrice.toFixed(2)}`;
                  SubtotalPrice = finalPrice.toFixed(2) / 3;

                  const parentLabel = document.querySelector(".la-choose-prescription-wrapper");
                  if (parentLabel && parentLabel.classList.contains("la-render-review")) {
                    document.querySelector(".la-lens-total-price strong").textContent = `${Symbolcurrency}${finalPrice.toFixed(2)}`;
                  }

              }
          });
        }

        //**********************  Add-on sum  ***************************/
                var discount = false;
                let total = 0;
                if(discount == true){
                  const oldPrices = document.querySelectorAll(".la-footer-addon-price span.old-price");
                      oldPrices.forEach(el => {
                          const text = el.textContent.trim();

                          const price = parseFloat(text.replace(/[^0-9.]/g, ""));

                          if (!isNaN(price)) {
                              total += price;
                          }
                      });
                } else{
                  const oldPrices = document.querySelectorAll(".la-footer-addon-price");
                      oldPrices.forEach(el => {
                          const text = el.textContent.trim();

                          const price = parseFloat(text.replace(/[^0-9.]/g, ""));

                          if (!isNaN(price)) {
                              total += price;
                          }
                      });
                }
                
                  const totalDiv = document.createElement("div");
                  totalDiv.className = "la-addon-price";
                  // totalDiv.textContent = `${Symbolcurrency}${total.toFixed(2)}`;

                  
                  const container = document.querySelector(".la-footer-addon-wrapper");
                  if (container) {
                    // if exist then remove
                    container.querySelector(".la-addon-price")?.remove();

                    const totalDiv = document.createElement("div");
                    totalDiv.className = "la-addon-price";

                    var discount = false;
                    if(discount == true){
                      const discounttt = `25`;
                      const discountedPricee = (total.toFixed(2) * (100 - discounttt) / 100).toFixed(2);
                      
                      totalDiv.innerHTML = `
                              <div class="la-addon-discount-price">
                                  <span class="old-price">${Symbolcurrency}${total.toFixed(2)}</span>
                                  <span class="final-price">
                                      ${Symbolcurrency}${discountedPricee}
                                  </span>
                              </div>
                          `;

                    }else{
                      totalDiv.textContent = `${Symbolcurrency}${total.toFixed(2)}`;
                    }

                    container.insertAdjacentElement("afterbegin", totalDiv);
                  }
            //********************************* Add-on Sum  *******************************/

        const interval = setInterval(() => {
          // console.log("SubtotalPrice", SubtotalPrice);
      const klarna = document.querySelectorAll("klarna-placement")[2];

      if (klarna && klarna.shadowRoot) {
        const message = klarna.shadowRoot.querySelector(".osm-message");

        if (message) {
          const strong = message.querySelector("strong")?.textContent || "";

          message.innerHTML = `
          ${
              SubtotalPrice
                ? `or 3× <strong>${Symbolcurrency}${SubtotalPrice.toFixed(2)}</strong> with`
                : `or 3× <strong>${strong}</strong> with`
            }
          `;

          // clearInterval(interval);
        }
      }

    }, 500);

    const element = document.querySelector(
  '#la-boxy-footer-modal'
);

if (element) {
   element.querySelectorAll('.prescription-dispatch-message').forEach((el) => {
  el.remove();
});

  const element1 = document.querySelector(
  '#la-boxy-footer-modal .la-boxy-layout-modal'
);
  element1.insertAdjacentHTML(
    'afterend',
    '<div class="prescription-dispatch-message">Next-day delivery available on most lenses (order by 3pm). Varifocals and stronger prescriptions are made to order 7-10 working days.</div>'
  );
}

    }, 10);

 function handleResize() {
    const modal = document.getElementById("la-boxy-footer-modal");

    if (!modal) return;

    if (window.outerWidth <= 767) {
        modal.style.display = "none";
    } else {
        modal.style.display = "flex";
    }
}

window.addEventListener("resize", handleResize);


});
document.addEventListener('LensAdvizor:render:uploadForm', function() {
  document.getElementById("wrapper-lensadvisor-jtpl").classList.add("review-page");

  if(EnableDescription == true){
    const description3 = `PD (pupillary distance) is the gap between your pupils — it centres your lenses correctly.`;
    document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
          'afterend', `<p class="la-prescription-description text-center">${description3}</p>`
    );
  }
  if(EnableTitle == true){
    const title3 = ``;
    if(title3 != ''){
      document.getElementById("la_prescriptionSelect_title").textContent = title3;
    }
  }

});
// document.addEventListener('LensAdvizor:render:readingForm', function() {
//    console.log("readingForm");
// });
document.addEventListener('LensAdvizor:render:manualEntryForm', function() {
 document.getElementById("wrapper-lensadvisor-jtpl").classList.add("review-page");
const overchargeelement = document.querySelector(".prescriptions-overcharge");
  if (overchargeelement) {
    overchargeelement.remove();
  }
 if(EnableDescription == true){
  const description4 = `If you know your values, pop them in below. Not sure on any box? Leave it — our opticians will check.`;
    document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
          'afterend', `<p class="la-prescription-description text-center">${description4}</p>`
    );
 }

 if(EnableTitle == true){
  const title4 = ``;
  if(title4 != ''){
    document.getElementById("la_prescriptionSelect_title").textContent = title4;
  }
}

//************************   SPH CYL Start     **************************/ 

const USEDFORVALUE1 = document.querySelector(".la-footer-frame-prescription.value1").textContent;
const USEDPRESVALUE3 = document.querySelector(".la-footer-frame-prescription.value3").textContent;
if (
    !USEDPRESVALUE3.includes("Mirror") &&
    !USEDPRESVALUE3.includes("mirror") &&
    !USEDFORVALUE1.includes("Occupational") &&
    !USEDFORVALUE1.includes("Varifocal")
) {
  const LeadTime = document.querySelector(".la-footer-frame-prescription.value9").textContent;
  function updatePrescriptionAvailability() {
      const ODSPH = parseFloat(document.getElementById('la-od_right-sph').value);
      const ODCYL = parseFloat(document.getElementById('la-od_right-cyl').value);

      const OSSPH = parseFloat(document.getElementById('la-os_left-sph').value);
      const OSCYL = parseFloat(document.getElementById('la-os_left-cyl').value);

      const hasNaN =
          isNaN(ODSPH) ||
          isNaN(ODCYL) ||
          isNaN(OSSPH) ||
          isNaN(OSCYL);

      const odInRange =
          ODSPH >= -6 && ODSPH <= 0 &&
          ODCYL >= -2 && ODCYL <= 0;

      const osInRange =
          OSSPH >= -6 && OSSPH <= 0 &&
          OSCYL >= -2 && OSCYL <= 0;

      if (hasNaN || (odInRange && osInRange)) {
          document.querySelector(".la-footer-frame-prescription.value9").textContent = LeadTime;
      } else {
          document.querySelector(".la-footer-frame-prescription.value9").textContent = "3-5 Days";
      }
  }

  // Initial check
  updatePrescriptionAvailability();

  // Check whenever value changes
  [
      'la-od_right-sph',
      'la-od_right-cyl',
      'la-os_left-sph',
      'la-os_left-cyl'
  ].forEach(function(id) {
      document.getElementById(id).addEventListener('change', updatePrescriptionAvailability);
  });
}
//************************   SPH CYL End     **************************/ 

});
function updateStepClass(wrapper) {
    wrapper.classList.forEach(cls => {
        if (cls.startsWith('step-')) {
            wrapper.classList.remove(cls);
        }
    });

    wrapper.classList.add(`step-${currentStep}`);
}

document.addEventListener('click', function (e) {
    if (e.target.matches('.la-steeper-back')) {
         if(document.querySelector(".la-choose-prescription-wrapper").classList.contains("la-render-addons")){
            if(nextDay == false){
              nextDay = false;
            }else{
              nextDay = true;
            }
        }else{
          nextDay = true;
        }
        
       setTimeout(() => {
        if(document.querySelector(".la-choose-prescription-wrapper").classList.contains("la-render-addons")){
            if(nextDay == false){
              nextDay = false;
            }else{
              nextDay = true;
            }
        }else{
          nextDay = true;
        }

        const wrapper = document.querySelector('.la-prescription-modal-content');
        if (!wrapper) return;

        currentStep = Math.max(1, currentStep - 2);

        updateStepClass(wrapper);
       }, 20);
       document.getElementById("wrapper-lensadvisor-jtpl").classList.remove("review-page");
       document.addEventListener('LensAdvizor:prescriptionTypes:rendered', function () {
        // document.querySelector(".la-footer-frame-prescription.value1").textContent = `—`;
        document.querySelector(".prescription-value-4").classList.add("hide-prescription");
        document.querySelector(".la-footer-frame-prescription.value3").textContent = `—`;
        document.querySelector(".prescription-value-1").classList.add("hide-prescription");
        document.querySelector(".prescription-value-9").classList.add("hide-prescription");
       });
       document.addEventListener('LensAdvizor:render:submissionMethods', function() {
        // document.querySelector(".la-footer-frame-prescription.value2").textContent = `—`;
        document.querySelector(".prescription-value-2").classList.add("hide-prescription");
       });
       document.addEventListener('LensAdvizor:lens:rendered', function(e) {
        if (e.detail.method == 'renderLensGroup') {
          // document.querySelector(".la-footer-frame-prescription.value3").textContent = `—`;
          document.querySelector(".prescription-value-3").classList.add("hide-prescription");

          // document.querySelector(".la-footer-frame-prescription.value4").textContent = `—`;
           document.querySelector(".prescription-value-4").classList.add("hide-prescription");

          //  document.querySelector(".la-footer-frame-prescription.value5").textContent = `—`;
         document.querySelector(".prescription-value-5").classList.add("hide-prescription");

        //  document.querySelector(".la-footer-frame-prescription.value6").textContent = `—`;
        document.querySelector(".prescription-value-6").classList.add("hide-prescription");

        // document.querySelector(".la-footer-frame-prescription.value7").textContent = `—`;
        document.querySelector(".prescription-value-7").classList.add("hide-prescription");

        // document.querySelector(".la-footer-frame-prescription.value8").textContent = `—`;
        document.querySelector(".prescription-value-8").classList.add("hide-prescription");
        document.querySelector(".prescription-value-9").classList.add("hide-prescription");
        }
        if (e.detail.method == 'renderLenses') {
          //  document.querySelector(".la-footer-frame-prescription.value4").textContent = `—`;
           document.querySelector(".prescription-value-4").classList.add("hide-prescription");

          //  document.querySelector(".la-footer-frame-prescription.value5").textContent = `—`;
         document.querySelector(".prescription-value-5").classList.add("hide-prescription");

        //  document.querySelector(".la-footer-frame-prescription.value6").textContent = `—`;
        document.querySelector(".prescription-value-6").classList.add("hide-prescription");

        // document.querySelector(".la-footer-frame-prescription.value7").textContent = `—`;
        document.querySelector(".prescription-value-7").classList.add("hide-prescription");

        // document.querySelector(".la-footer-frame-prescription.value8").textContent = `—`;
        document.querySelector(".prescription-value-8").classList.add("hide-prescription");
        document.querySelector(".prescription-value-9").classList.remove("hide-prescription");
        }
       });
       document.addEventListener('LensAdvizor:lensOption1:rendered', function() {
        //  document.querySelector(".la-footer-frame-prescription.value5").textContent = `—`;
         document.querySelector(".prescription-value-5").classList.add("hide-prescription");

        //  document.querySelector(".la-footer-frame-prescription.value6").textContent = `—`;
        document.querySelector(".prescription-value-6").classList.add("hide-prescription");

        // document.querySelector(".la-footer-frame-prescription.value7").textContent = `—`;
        document.querySelector(".prescription-value-7").classList.add("hide-prescription");

        // document.querySelector(".la-footer-frame-prescription.value8").textContent = `—`;
        document.querySelector(".prescription-value-8").classList.add("hide-prescription");
        document.querySelector(".prescription-value-9").classList.remove("hide-prescription");
       });
       document.addEventListener('LensAdvizor:lensOption2:rendered', function() {
        // document.querySelector(".la-footer-frame-prescription.value6").textContent = `—`;
        document.querySelector(".prescription-value-6").classList.add("hide-prescription");

        // document.querySelector(".la-footer-frame-prescription.value7").textContent = `—`;
        document.querySelector(".prescription-value-7").classList.add("hide-prescription");

        // document.querySelector(".la-footer-frame-prescription.value8").textContent = `—`;
        document.querySelector(".prescription-value-8").classList.add("hide-prescription");
        document.querySelector(".prescription-value-9").classList.remove("hide-prescription");
       });
       document.addEventListener('LensAdvizor:lensOption3:rendered', function() {
        // document.querySelector(".la-footer-frame-prescription.value7").textContent = `—`;
        document.querySelector(".prescription-value-7").classList.add("hide-prescription");

        // document.querySelector(".la-footer-frame-prescription.value8").textContent = `—`;
        document.querySelector(".prescription-value-8").classList.add("hide-prescription");
        document.querySelector(".prescription-value-9").classList.remove("hide-prescription");
       });
       document.addEventListener('LensAdvizor:addOns:rendered', function() {
        //  document.querySelector(".la-footer-frame-prescription.value8").textContent = `—`;
         document.querySelector(".prescription-value-8").classList.add("hide-prescription");
         document.querySelector(".prescription-value-9").classList.remove("hide-prescription");
       });


    }
    if (e.target.matches('.la-prescription-modal-close')) {
        currentStep = 0;
        summary = false;
        lensPrice = false;
         LensAdvizor.prevSelections = {};
         selectedlens = false;

        const wrapper = document.getElementById("wrapper-lensadvisor-jtpl");
        if (wrapper) {
            wrapper.remove();
        }
    }
    if (e.target.matches('.la-skip-add-on')) {

      const Value1 = document.querySelector(".la-footer-frame-prescription.value1").textContent;
      if(Value1.includes("Distance") || Value1.includes("Reading")){
        const elements = document.querySelectorAll('.la-footer-addon-wrapper .la-addon-price');
        elements.forEach(el => {
            const price = parseFloat(el.textContent.replace(/[^0-9.-]+/g, ''));
            if (price <= 0) {
                document.querySelector(".prescription-value-8").classList.add("hide-prescription");
            }
        });
      }else{
        document.querySelector(".prescription-value-8").classList.add("hide-prescription");
      }

    }
});
//*********************** Your Build summary and add step class end *******************************/ 

//*********************** Add currency symbol for lens start *******************************/ 
let lensPrice = false;
let lensPriceDiv;
document.addEventListener('LensAdvizor:lensOptions:rendered', function() {
  if(lensPrice == false){
    var currency = document.body.getAttribute('theme-currency');
    lensPrice = true;
    if(window.outerWidth >= 768){
    lensPriceDiv = document.querySelector(
          '.fe-flow-jtpl .la-footer-row-wrapper:nth-of-type(4):not(.la-d-none) .la-footer-lens-price'
        );
      } else{
        lensPriceDiv = document.querySelector(
          '.fe-flow-jtpl .la-footer-row-wrapper:nth-of-type(5):not(.la-d-none) .la-footer-lens-price'
        );
      }
        if (lensPriceDiv && !lensPriceDiv.parentElement.querySelector('.currency-symbol')) {
          lensPriceDiv.insertAdjacentHTML(
            'beforebegin',
            `<div class="currency-symbol">${currency}</div>`
          );
        }
    }
    var discount = false;
    if(discount == true){
      document.querySelector(".discount-summary-cart").classList.remove("hide-summary");
    }
});
//*********************** Add currency symbol for lens end *******************************/ 

//*********************** Update value for Used For start *******************************/ 
document.addEventListener('LensAdvizor:prescriptionTypes:rendered', function () {
  // hiddenInputTextt = `
  //     <input id="hiddenTryOnProperty" type="hidden" name='la-properties[_modelcode]' value="true" >
  //   `
  //   wrapperr = document.querySelector('.la-prescription-modal-wrapper')
  //   wrapperr.insertAdjacentHTML('beforeend', hiddenInputTextt)    
document.querySelector(".la-prescription-modal-content-body").classList.remove("la-render-addons-jtpl");
  document.querySelector(".la-prescription-modal-content-body").classList.remove("la-render-group");
  document.querySelectorAll(".la-label-btn-wrapper").forEach(function (el) {
    el.addEventListener("click", function () {
        const text = this.querySelector(".la-label-content-box .la-label-title")?.textContent.trim();
            document.querySelector(".la-footer-frame-prescription.value1").textContent = text;
            document.querySelector(".prescription-value-1").classList.remove("hide-prescription");
        });
  });
      setInterval(() => {
        const priceText = document
          .querySelector(".la-footer-row.la-subtotal .la-subtotal-price")
          ?.textContent.trim();

        const price = priceText
          ?.replace(/[^\d.]/g, "")
          .replace(".", "");

        const elements = document.querySelectorAll("[data-purchase-amount]");

          if (price) {
            elements.forEach((element) => {
              element.setAttribute("data-purchase-amount", price);
            });
          }
         const klarnaElements = document.querySelectorAll("#wrapper-lensadvisor-jtpl klarna-placement");

        klarnaElements.forEach((klarnaElement) => {
          const shadowRoot = klarnaElement.shadowRoot;

          if (!shadowRoot) return;

          // Style sirf ek baar add hogi har shadowRoot me
          if (!shadowRoot.querySelector("#klarna-custom-style")) {
            const style = document.createElement("style");
            style.id = "klarna-custom-style";
            style.textContent = `
                  .container {
                    flex-direction: row-reverse !important;
                    background: transparent !important; 
                    border: 0 !important;
                    padding: 0 !important;
                    justify-content: flex-end !important;
                    position: relative;
                  }
                  .container.order-summary-klarna{
                    justify-content: center !important;
                  }
                  .container button.link {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: auto;
                    font-size: 0;
                  }
                  .container .text-wrapper p.legal{
                    display:none !important;
                  }
                  .container .text-wrapper {
                    margin-left: 0;
                    color: #8a857d;
                    font-size: 12px;
                    line-height: normal;
                    margin-right: 3px;
                  }
                  .container .text-wrapper strong {
                    font-weight: normal;
                  }
                  .container .badge svg {
                    height: 18px;
                    width: 40px;
                    // transform: translateY(1px);
                  }
                  @media (max-width: 1140px) {
                    .container .text-wrapper {
                      font-size: 10px;
                    }
                  }
                  @media (max-width: 994px) {
                    .container .text-wrapper {
                      font-size: 8.5px;
                    }
                  }
                  @media (max-width: 767px) {
                   .desktop-klarna .container {
                      justify-content: center !important;
                    }
                    .container .text-wrapper {
                      font-size: 11px;
                    }
                  }
                `;

                klarnaElement.shadowRoot.appendChild(style);
            }
          });
      }, 10);
      if(document.querySelector(".la-progress-bar-step")){
        document.querySelector(".la-progress-bar-step").textContent = "Step 1 of 8";
      }else{
        document.querySelector(".la-progress-bar.la-transparent-bg").insertAdjacentHTML(
            'afterend', `<div class="la-progress-bar-step">Step 1 of 8</div>`);
      }

      if(EnableDescription == true){
        const description1 = `Choose Your Prescription Type`;
        document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
              'afterend', `<p class="la-prescription-description text-center">${description1}</p>`
        );
      }
      if(EnableTitle == true){
        const title1 = `What are you using your glasses for?`;
        if(title1 != ''){
          document.getElementById("la_prescriptionSelect_title").textContent = title1;
        }
      }
      
});
//*********************** Update value for Used For end *******************************/ 

//*********************** Update value for Method start *******************************/ 
var submissionMethods = false;
document.addEventListener('LensAdvizor:render:submissionMethods', function() {
  document.querySelectorAll(".la-label-btn-wrapper").forEach(function (el) {
    el.addEventListener("click", function () {
        const text = this.querySelector(".la-label-content-box .la-label-title")?.textContent.trim();
            document.querySelector(".la-footer-frame-prescription.value2").textContent = text;
            document.querySelector(".prescription-value-2").classList.remove("hide-prescription");
        });
  });
    setInterval(() => {
  const priceText = document
    .querySelector(".la-footer-row.la-subtotal .la-subtotal-price")
    ?.textContent.trim();

  const price = priceText
    ?.replace(/[^\d.]/g, "")
    .replace(".", "");

  const elements = document.querySelectorAll("[data-purchase-amount]");

  if (price) {
    elements.forEach((element) => {
      element.setAttribute("data-purchase-amount", price);
    });
  }
  const klarnaElements = document.querySelectorAll("#wrapper-lensadvisor-jtpl klarna-placement");

        klarnaElements.forEach((klarnaElement) => {
          const shadowRoot = klarnaElement.shadowRoot;

          if (!shadowRoot) return;

          // Style sirf ek baar add hogi har shadowRoot me
          if (!shadowRoot.querySelector("#klarna-custom-style")) {
            const style = document.createElement("style");
            style.id = "klarna-custom-style";
            style.textContent = `
                  .container {
                    flex-direction: row-reverse !important;
                    background: transparent !important;
                    border: 0 !important;
                    padding: 0 !important;
                    justify-content: flex-end !important;
                    position: relative;
                  }
                  .container.order-summary-klarna{
                    justify-content: center !important;
                  }
                  .container button.link {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: auto;
                    font-size: 0;
                  }
                  .container .text-wrapper p.legal{
                    display:none !important;
                  }
                  .container .text-wrapper {
                    margin-left: 0;
                    color: #8a857d;
                    font-size: 12px;
                    line-height: normal;
                    margin-right: 3px;
                  }
                  .container .text-wrapper strong {
                    font-weight: normal;
                  }
                  .container .badge svg {
                    height: 18px;
                    width: 40px;
                    // transform: translateY(1px);
                  }
                  @media (max-width: 1140px) {
                    .container .text-wrapper {
                      font-size: 10px;
                    }
                  }
                  @media (max-width: 994px) {
                    .container .text-wrapper {
                      font-size: 8.5px;
                    }
                  }
                  @media (max-width: 767px) {
                   .desktop-klarna .container {
                      justify-content: center !important;
                    }
                    .container .text-wrapper {
                      font-size: 11px;
                    }
                  }
                `;

                klarnaElement.shadowRoot.appendChild(style);
            }
          });
}, 10);
document.querySelector(".la-progress-bar-step").textContent = "Step 2 of 8";

    if(EnableDescription == true){
      const description2 = `Do it now, or check out and send it later — whatever’s easiest.`;
      document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
            'afterend', `<p class="la-prescription-description text-center">${description2}</p>`
      );
    }
    if(EnableTitle == true){
      const title2 = ``;
      if(title2 != ''){
        document.getElementById("la_prescriptionSelect_title").textContent = title2;
      }
    }
  submissionMethods = true;
    setTimeout(function(){
    const valueDelivery = document.querySelector(".summary-prescription-title.value-option.value9").textContent;
    document.getElementById("nextdayProperty").value = valueDelivery;
    if (window.LensAdvizor) {
        if (!window.LensAdvizor.customFieldData) {
            window.LensAdvizor.customFieldData = {};
        }
        window.LensAdvizor.customFieldData["Delivery"] = valueDelivery;
    }
  }, 10);
});
//*********************** Update value for Method end *******************************/ 

document.addEventListener('LensAdvizor:lens:rendered', function(e) {
  console.log(e.detail.method);
  if (e.detail.method == 'renderHeaderLenses') {
      document.querySelectorAll(".la-label-btn-wrapper").forEach(function (el) {
        el.addEventListener("click", function () {
            const text = this.querySelector(".la-label-content-box .la-label-title")?.textContent.trim();
                document.querySelector(".la-footer-frame-prescription.value4").textContent = text;

                if(EnableDiscount == false){
                  let OrignalpriceBox;
                    OrignalpriceBox = this.querySelector(".la-label-price").textContent;
                  //  console.log(OrignalpriceBox);
                  if (OrignalpriceBox !== null && OrignalpriceBox !== undefined && OrignalpriceBox !== ""){
                    document.querySelector(".la-footer-frame-prescription.value4").setAttribute("new-price", OrignalpriceBox);
                  }
                } else{
                  const priceRow = this.querySelector(".la-label-price .price-box");
                  if (priceRow) {
                      document.querySelector(".la-footer-frame-prescription.value4").setAttribute("new-price", priceRow.outerHTML);
                    }
                }
                document.querySelector(".prescription-value-4").classList.remove("hide-prescription");
            });
      });
  }
    if (e.detail.method == 'renderLensGroup') {
      document.querySelector(".la-prescription-modal-content-body").classList.add("la-render-group");
      document.querySelector(".la-prescription-modal-content-body").classList.remove("la-render-products");
        document.querySelectorAll(".la-label-btn-wrapper").forEach(function (el) {
          el.addEventListener("click", function () {
              const text = this.querySelector(".la-label-content-box .la-label-title")?.textContent.trim();
                  document.querySelector(".la-footer-frame-prescription.value3").textContent = text;

                    document.querySelector(".prescription-value-3").classList.remove("hide-prescription");
                  
              });
        });
          setInterval(() => {
            const priceText = document
              .querySelector(".la-footer-row.la-subtotal .la-subtotal-price")
              ?.textContent.trim();

            const price = priceText
              ?.replace(/[^\d.]/g, "")
              .replace(".", "");

            const elements = document.querySelectorAll("[data-purchase-amount]");

          if (price) {
            elements.forEach((element) => {
              element.setAttribute("data-purchase-amount", price);
            });
          }
            const klarnaElements = document.querySelectorAll("#wrapper-lensadvisor-jtpl klarna-placement");

        klarnaElements.forEach((klarnaElement) => {
          const shadowRoot = klarnaElement.shadowRoot;

          if (!shadowRoot) return;

          // Style sirf ek baar add hogi har shadowRoot me
          if (!shadowRoot.querySelector("#klarna-custom-style")) {
            const style = document.createElement("style");
            style.id = "klarna-custom-style";
            style.textContent = `
                  .container {
                    flex-direction: row-reverse !important;
                    background: transparent !important;
                    border: 0 !important;
                    padding: 0 !important;
                    justify-content: flex-end !important;
                    position: relative;
                  }
                  .container.order-summary-klarna{
                    justify-content: center !important;
                  }
                  .container button.link {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: auto;
                    font-size: 0;
                  }
                  .container .text-wrapper p.legal{
                    display:none !important;
                  }
                  .container .text-wrapper {
                    margin-left: 0;
                    color: #8a857d;
                    font-size: 12px;
                    line-height: normal;
                    margin-right: 3px;
                  }
                  .container .text-wrapper strong {
                    font-weight: normal;
                  }
                  .container .badge svg {
                    height: 18px;
                    width: 40px;
                    // transform: translateY(1px);
                  }
                  @media (max-width: 1140px) {
                    .container .text-wrapper {
                      font-size: 10px;
                    }
                  }
                  @media (max-width: 994px) {
                    .container .text-wrapper {
                      font-size: 8.5px;
                    }
                  }
                  @media (max-width: 767px) {
                   .desktop-klarna .container {
                      justify-content: center !important;
                    }
                    .container .text-wrapper {
                      font-size: 11px;
                    }
                  }
                `;

                klarnaElement.shadowRoot.appendChild(style);
            }
          });
          }, 10);

          if(submissionMethods == false){
            document.querySelector(".la-progress-bar-step").textContent = "Step 2 of 7";
          }else{
            document.querySelector(".la-progress-bar-step").textContent = "Step 3 of 8";
          }

          if(EnableDescription == true){
            const description5 = `Choose Lens Group`;
            document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
                  'afterend', `<p class="la-prescription-description text-center">${description5}</p>`
            );
          }
          if(EnableTitle == true){
          const title5 = `How should your lenses behave in light?`;
          if(title5 != ''){
           document.getElementById("la_prescriptionSelect_title").textContent = title5;
          }
        }
        if(document.body.classList.contains("glasses-jtpl")){

  // Only inject once — don't re-insert on every render
  if (!document.querySelector(".sunglasses-options")) {

    const lensGroup = document.querySelectorAll(".la-label-btn-wrapper");
    lensGroup[lensGroup.length - 1].insertAdjacentHTML("afterend", `<div class="la-label-btn-wrapper  la-horizontal-boxy-label-wrapper sunglasses-options">
                <label class="la-label-btn sunglasses-options">
                    <div class="la-label-image-wapper">
                    <div class="la-label-image">
                        <img src="https://cdn.shopify.com/s/files/1/0601/9045/8085/files/FE-framesunglasses.png?v=1788429039" alt="Sunglasses" loading="lazy" srcset="https://cdn.shopify.com/s/files/1/0601/9045/8085/files/FE-framesunglasses.png?v=1788429039 60w,https://cdn.shopify.com/s/files/1/0601/9045/8085/files/FE-framesunglasses.png?v=1788429039 90w,https://cdn.shopify.com/s/files/1/0601/9045/8085/files/FE-framesunglasses.png?v=1788429039 45w" sizes="(max-width: 710px) 90px,(max-width: 475px) 45px,60px">
                    </div>
                    </div>
                    <div class="la-label-content-box">
                        <div class="la-label-title">
                            <la-translate data-la-translate-as="span" style="display: contents;">Sunglasses Options</la-translate>
                        </div>
                        <div class="la-label-description">
                            <la-translate data-la-translate-as="span" style="display: contents;">Prescription sunglasses from a clear frame.</la-translate>
                        </div>
                    </div>
                </label>
            </div>

            <div class="la-label-btn-wrapper  la-horizontal-boxy-label-wrapper glasses-options" style="display: none;">
                <label class="la-label-btn glasses-options">
                    <div class="la-label-image-wapper">
                    <div class="la-label-image">
                        <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="Glasses" loading="lazy" srcset="https://cdn.shopify.com/s/files/1/0601/9045/8085/files/Glasses_fc64d67e-8ba2-46aa-b2f2-e3e565531213.jpg?v=1784360449 60w,https://cdn.shopify.com/s/files/1/0601/9045/8085/files/Glasses_fc64d67e-8ba2-46aa-b2f2-e3e565531213.jpg?v=1784360449 90w,https://cdn.shopify.com/s/files/1/0601/9045/8085/files/Glasses_fc64d67e-8ba2-46aa-b2f2-e3e565531213.jpg?v=1784360449 45w" sizes="(max-width: 710px) 90px,(max-width: 475px) 45px,60px">
                    </div>
                    </div>
                    <div class="la-label-content-box">
                        <div class="la-label-title">
                            <la-translate data-la-translate-as="span" style="display: contents;">Glasses Options</la-translate>
                        </div>
                        <div class="la-label-description">
                            <la-translate data-la-translate-as="span" style="display: contents;">Prescription glasses.</la-translate>
                        </div>
                    </div>
                </label>
            </div>`);

    const sunglassesBtn = document.querySelector(".sunglasses-options");
    const glassesBtn = document.querySelector(".glasses-options");

    sunglassesBtn.addEventListener("click", function (e) {
      e.preventDefault();
      this.style.display = "none";

      const backButton = document.querySelector(".la-steeper-back");
      if (backButton) {
        backButton.style.display = "none";
        // Don't create a duplicate back-glasses button if one already exists
        if (!document.querySelector(".back-glasses")) {
          backButton.insertAdjacentHTML('afterend', `<button class="la-steeper-back back-glasses" aria-label="Back"></button>`);
        }
      }

      const showLenses = ["Full Tint", "Gradient", "Polarised", "Mirror"];
      const hideLenses = ["Clear", "Light Sensitive"];
      document.querySelectorAll(".la-label-btn-wrapper").forEach(item => {
        const title = item.querySelector(".la-label-title")?.textContent.trim() || "";
        if (showLenses.some(l => title.includes(l))){
           item.style.display = "block";
           item.classList.add("show-lenses");
        }
        if (hideLenses.some(l => title.includes(l))){
           item.style.display = "none";
           item.classList.remove("show-lenses");
        }
      });

      const backGlasses = document.querySelector(".back-glasses");
      if (backGlasses) {
        backGlasses.addEventListener("click", function () {
          const glassesOptions = document.querySelector(".glasses-options");
          if (glassesOptions) glassesOptions.click();   // ← guarded now
          this.remove();
          const backBtn = document.querySelector(".la-steeper-back");
          if (backBtn) backBtn.style.display = "block";
        });
      }
    });

    if (glassesBtn) {
      glassesBtn.addEventListener("click", function (e) {
        e.preventDefault();
        this.style.display = "none";
        const sunglasses = document.querySelector(".sunglasses-options");
        if (sunglasses) sunglasses.style.display = "block";

        const hideLenses = ["Full Tint", "Gradient", "Polarised", "Mirror"];
        const showLenses = ["Clear", "Light Sensitive"];
        document.querySelectorAll(".la-label-btn-wrapper").forEach(item => {
          const title = item.querySelector(".la-label-title")?.textContent.trim() || "";
          if (showLenses.some(l => title.includes(l))){
             item.style.display = "block";
             item.classList.add("show-lenses");
          }
          if (hideLenses.some(l => title.includes(l))){
             item.style.display = "none";
             item.classList.remove("show-lenses");
          }
        });
      });
    }

    const lensType = document.querySelector(".la-footer-frame-prescription.value3").textContent;
      const lenstitles = ["Full Tint","Gradient","Polarised", "Mirror"];
        setTimeout(()=> {
          if (lenstitles.includes(lensType)) {
                document.querySelector(".sunglasses-options").click();
            }
        }, 50);

  }
}

//************************  money format for fashion lens group  start  *****************************// 
  const isocurrency = document.body.getAttribute('current-isocode');

const roundingRules = {
  // Round up to nearest £1 (GBP base — UK, Tristan da Cunha, British Isles)
  GBP: (price) => Math.ceil(price),

  // Round up to nearest $1 (Canada)
  CAD: (price) => Math.ceil(price),

  // Round up to nearest $1 (United States, Rest of World)
  USD: (price) => Math.ceil(price),

  // Round up to nearest A$1 (Australia)
  AUD: (price) => Math.ceil(price),

  // Round up to nearest €0.95 (Germany, Europe excl. Germany, Ireland, Luxembourg)
  EUR: (price) => Math.floor(price) + 0.95,

  // Round up to nearest ¥100 (Japan)
  JPY: (price) => Math.ceil(price / 100) * 100,

  // Round up to nearest ₩1000 (South Korea)
  KRW: (price) => Math.ceil(price / 1000) * 1000,

  // Round up to nearest ¥1 (China)
  CNY: (price) => Math.ceil(price),

  // Round up to nearest ₹100 (India)
  INR: (price) => Math.ceil(price / 100) * 100,

  // Round up to nearest ﷼1 (Saudi Arabia)
  SAR: (price) => Math.ceil(price),

  // Round up to nearest ₪1 (Israel)
  ILS: (price) => Math.ceil(price),

  // Round up to nearest د.إ1 (United Arab Emirates)
  AED: (price) => Math.ceil(price),
};

const defaultRounding = (price) => Math.ceil(price);

document.querySelectorAll(".la-label-price").forEach(price => {
  const gbpPrice = parseFloat(price.textContent.replace(/[^\d.]/g, ""));

  const convertedPrice = gbpPrice * Number(Shopify.currency.rate);

  const roundFn = roundingRules[isocurrency] || defaultRounding;
  const finalPrice = roundFn(convertedPrice);

  price.textContent = `${Symbolcurrency}${finalPrice.toLocaleString()}`;
});

  //************************  money format for fashion lens group  end  *****************************// 
  document.querySelector(".la-prescription-modal-content-body").classList.remove("la-render-addons-jtpl");
  const USEDFOR = document.querySelector(".la-footer-frame-prescription.value1").textContent;
  if(USEDFOR.includes("Fashion")){
    document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
    document.querySelector(".prescription-value-9").classList.remove("hide-prescription");
  }
    }

    if (e.detail.method == 'renderLenses' || e.detail.method == 'renderHeaderLenses') {

      setTimeout(function(){
        document.querySelectorAll('.la-label-btn-wrapper').forEach(function (btn) {
            btn.addEventListener('click', function () {
                const contentWrapper = this.querySelector('.la-label-content-wrapper');
                if (contentWrapper?.querySelector('.delivery-badge')) {
                    nextDay = true;
                    document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                }else{
                    nextDay = false;
                    const USEDFOR = document.querySelector(".la-footer-frame-prescription.value1").textContent;
                    const USEDPRES = document.querySelector(".la-footer-frame-prescription.value3").textContent;
                    const LENSPRES = document.querySelector(".la-footer-frame-prescription.value4").textContent;
                    const LENSCOLOUR = document.querySelector(".la-footer-frame-prescription.value5").textContent;

                    if(USEDFOR.includes("Varifocal")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                    } else if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
                      document.querySelectorAll(".card-info-wrapper").forEach(function (element) {
                        element.innerHTML = `
                          <div class="dispatch-text">
                            <p class="dispatch-badge">Dispatch 3-5 Days</p>
                          </div>`;
                        });
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                    } else if(LENSPRES.includes("Ray Ban")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;  
                    } else if(LENSPRES.includes("Oakley")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                    } else if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `5-7 Days`;
                    } else if(USEDFOR.includes("Occupational")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                    } else if(USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                    } else if(USEDFOR.includes("Ready Reader")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `1-3 Days`;
                    } else if(USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                    } else{
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                    }
                      
                }
            });
        });
        const USEDFOR = document.querySelector(".la-footer-frame-prescription.value1").textContent;
        const USEDPRES = document.querySelector(".la-footer-frame-prescription.value3").textContent;
        const LENSPRES = document.querySelector(".la-footer-frame-prescription.value4").textContent;
        const LENSCOLOUR = document.querySelector(".la-footer-frame-prescription.value5").textContent;

          if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror") || USEDFOR.includes("Varifocal") || USEDFOR.includes("Occupational") || USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised") || USEDFOR.includes("Ready Reader") || USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
              nextDay = false;
          }
          if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
            nextDay = false;
          }

        if(nextDay == false){
          document.querySelectorAll('.la-label-btn-wrapper').forEach(function (btn) {
              const delvbadge = btn.querySelector('.delivery-badge');
              if (delvbadge) {
                  delvbadge.remove();
                    if(USEDFOR.includes("Varifocal")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                    } else if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
                      document.querySelectorAll(".card-info-wrapper").forEach(function (element) {
                        element.innerHTML = `
                          <div class="dispatch-text">
                            <p class="dispatch-badge">Dispatch 3-5 Days</p>
                          </div>`;
                        });
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                    } else if(LENSPRES.includes("Ray Ban")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                    } else if(LENSPRES.includes("Oakley")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                    } else if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `5-7 Days`;
                    } else if(USEDFOR.includes("Occupational")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                    } else if(USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                    } else if(USEDFOR.includes("Ready Reader")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `1-3 Days`;
                    } else if(USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                    } else{
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                    }
              }
              if(USEDFOR.includes("Varifocal")){
                document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
              } else if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
                document.querySelectorAll(".card-info-wrapper").forEach(function (element) {
                  element.innerHTML = `
                    <div class="dispatch-text">
                      <p class="dispatch-badge">Dispatch 3-5 Days</p>
                    </div>`;
                  });
                document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
              } else if(LENSPRES.includes("Ray Ban")){
                document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;  
              } else if(LENSPRES.includes("Oakley")){
                document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
              } else if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror")){
                document.querySelector(".la-footer-frame-prescription.value9").textContent = `5-7 Days`;
              } else if(USEDFOR.includes("Occupational")){
                document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
              } else if(USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised")){
                document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
              } else if(USEDFOR.includes("Ready Reader")){
                document.querySelector(".la-footer-frame-prescription.value9").textContent = `1-3 Days`;
              } else if(USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
              } else{
                document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
              }
          });
        }else{
          document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
        }
      }, 10);

      document.querySelector(".prescription-value-4").classList.add("hide-prescription");
      document.querySelector(".prescription-value-9").classList.remove("hide-prescription");
      const element = document.querySelector(".back-glasses");
      if (element) {
          element.remove();
      }
      const backButton = document.querySelector(".la-steeper-back");
      backButton.style.display = "block";

     const usedForValue = document.querySelector(".value-option.value1")?.textContent.trim().toLowerCase();
     const modalBody = document.querySelector(".la-prescription-modal-content-body");
     modalBody.classList.remove("la-render-group", "la-render-addons-jtpl", "la-render-products");

     if (usedForValue && (usedForValue.includes("blue light") || usedForValue.includes("ready reader"))){
       modalBody.classList.add("la-render-addons-jtpl");
       document.getElementById("la_prescriptionSelect_title").textContent ="Add Protection & Extras";
       document.querySelector(".la-choose-prescription-wrapper").classList.add("la-render-addons-lens");
       setTimeout(()=> {
        const elements = document.querySelector(".la-prescription-description");
        if (elements) {
          elements.style.display = "none";
        }
      }, 50);
      const addonTitles = [
        `Do you use computers and screens a lot? Add a blue-light coating.`,
        `Accidental damage cover for scratches or breakage.`,
        ``
      ];

      document.querySelectorAll(".la-label-btn-wrapper").forEach(function (item, index) {
        const title = addonTitles[index];

        if (title && !item.querySelector(".addon-title")) {
          item.insertAdjacentHTML(
            "afterbegin",
            `<div class="addon-title">${title}</div>`
          );     
        }
      });

     } else {
       modalBody.classList.add("la-render-products");
      if (document.body.classList.contains("single-tru-flow")) {
        document.getElementById("la_prescriptionSelect_title").textContent = "Your Prescription Lens";
      }
     }
    
        setTimeout(function(){
        document.querySelectorAll(".la-label-btn-wrapper").forEach(wrapper => {
          const priceDiv = wrapper.querySelector(".la-label-price");
          if (priceDiv && !wrapper.querySelector(".la-btn-group")) {
              const btnGroup = document.createElement("div");
              btnGroup.className = "la-btn-group";
              let htmlchoose = '';
              if(document.body.classList.contains("single-tru-flow")){
                 htmlchoose = `
                  <div type="button" class="choose-btn selected">Selected ✓</div>
                  <div type="button" class="choose-btn">Proceed</div>
              `;
              }else{
                htmlchoose = `
                  <div type="button" class="choose-btn selected">Selected ✓</div>
                  <div type="button" class="choose-btn">Choose</div>
              `;
              }
              btnGroup.innerHTML = htmlchoose;

              // Insert after .la-label-price
              priceDiv.insertAdjacentElement("afterend", btnGroup);
          }
        if (document.querySelector(".la-render-addons-jtpl")) {
            document.querySelectorAll(".la-btn-group").forEach(group => {
                group.style.display = "none";
            });
        }
        });

        const divs = document.querySelectorAll(".la-label-image");
            if (divs.length > 1) {
              const lenSTypes = document.querySelector(".la-footer-frame-prescription.value3").textContent;

              const prescType = document.querySelector(".la-footer-frame-prescription.value1").textContent;
            const PrescriptionType = `distance, reading`;
              
              if(PrescriptionType.includes(prescType.toLowerCase()) && lenSTypes == "Clear" && (productVendor === 'chanel' || productVendor === 'cartier')){
                divs[2].closest(".la-label-image-wapper").classList.add("badge-image-content");
                divs[2].insertAdjacentHTML("beforeend", "<div class='hero-badge-outer'><span class='hero-badge'>OPTICIAN'S CHOICE</span></div>");
                if (document.querySelector(".la-render-addons-jtpl")) {
                    divs[2].querySelector(".hero-badge-outer")?.style.setProperty("display", "none");
                }
              }else{
              divs[1].closest(".la-label-image-wapper").classList.add("badge-image-content");
                divs[1].insertAdjacentHTML("beforeend", "<div class='hero-badge-outer'><span class='hero-badge'>OPTICIAN'S CHOICE</span></div>");
                if (document.querySelector(".la-render-addons-jtpl")) {
                    divs[1].querySelector(".hero-badge-outer")?.style.setProperty("display", "none");
                }
              }
            }

         }, 10);
        document.querySelectorAll(".la-label-btn-wrapper").forEach(function (el) {
          el.addEventListener("click", function () {
            console.log("el",el);
              const text = this.querySelector(".la-label-content-box .la-label-title")?.textContent.trim();
                  document.querySelector(".la-footer-frame-prescription.value4").textContent = text;

                  if(EnableDiscount == false){
                    let OrignalpriceBox;
                     OrignalpriceBox = this.querySelector(".la-label-price").textContent;
                    //  console.log(OrignalpriceBox);
                    if (OrignalpriceBox !== null && OrignalpriceBox !== undefined && OrignalpriceBox !== ""){
                      document.querySelector(".la-footer-frame-prescription.value4").setAttribute("new-price", OrignalpriceBox);
                    }
                  } else{
                    const priceRow = this.querySelector(".la-label-price .price-box");
                    if (priceRow) {
                        document.querySelector(".la-footer-frame-prescription.value4").setAttribute("new-price", priceRow.outerHTML);
                      }
                  }

                // const oldPrice = this.querySelector(".la-label-price .price-row .old-price")?.textContent.trim();
                // const newPrice = this.querySelector(".la-label-price .price-row .new-price")?.textContent.trim();
                // document.querySelector(".la-footer-frame-prescription.value4").setAttribute("old-price", oldPrice);
                

                  document.querySelector(".prescription-value-4").classList.remove("hide-prescription");
              });
        });
          setInterval(() => {
            const priceText = document
              .querySelector(".la-footer-row.la-subtotal .la-subtotal-price")
              ?.textContent.trim();

            const price = priceText
              ?.replace(/[^\d.]/g, "")
              .replace(".", "");

            const elements = document.querySelectorAll("[data-purchase-amount]");

          if (price) {
            elements.forEach((element) => {
              element.setAttribute("data-purchase-amount", price);
            });
          }
            const klarnaElements = document.querySelectorAll("#wrapper-lensadvisor-jtpl klarna-placement");

        klarnaElements.forEach((klarnaElement) => {
          const shadowRoot = klarnaElement.shadowRoot;

          if (!shadowRoot) return;

          // Style sirf ek baar add hogi har shadowRoot me
          if (!shadowRoot.querySelector("#klarna-custom-style")) {
            const style = document.createElement("style");
            style.id = "klarna-custom-style";
            style.textContent = `
                  .container {
                    flex-direction: row-reverse !important;
                    background: transparent !important;
                    border: 0 !important;
                    padding: 0 !important;
                    justify-content: flex-end !important;
                    position: relative;
                  }
                  .container.order-summary-klarna{
                    justify-content: center !important;
                  }
                  .container button.link {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: auto;
                    font-size: 0;
                  }
                  .container .text-wrapper p.legal{
                    display:none !important;
                  }
                  .container .text-wrapper {
                    margin-left: 0;
                    color: #8a857d;
                    font-size: 12px;
                    line-height: normal;
                    margin-right: 3px;
                  }
                  .container .text-wrapper strong {
                    font-weight: normal;
                  }
                  .container .badge svg {
                    height: 18px;
                    width: 40px;
                    // transform: translateY(1px);
                  }
                  @media (max-width: 1140px) {
                    .container .text-wrapper {
                      font-size: 10px;
                    }
                  }
                  @media (max-width: 994px) {
                    .container .text-wrapper {
                      font-size: 8.5px;
                    }
                  }
                  @media (max-width: 767px) {
                   .desktop-klarna .container {
                      justify-content: center !important;
                    }
                    .container .text-wrapper {
                      font-size: 11px;
                    }
                  }
                `;

                klarnaElement.shadowRoot.appendChild(style);
            }
          });
          }, 10);
          if(submissionMethods == false){
            document.querySelector(".la-progress-bar-step").textContent = "Step 3 of 7";
          }else{
            document.querySelector(".la-progress-bar-step").textContent = "Step 4 of 8";
          }

        if(EnableDescription == true){
          const description6 = `Every package includes your lenses and coatings.`;
          document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
                'afterend', `<p class="la-prescription-description text-center">${description6}</p>`
          );
        }
        if(EnableTitle == true){
          const title6 = ``;
          if(title6 != ''){
           document.getElementById("la_prescriptionSelect_title").textContent = title6;
          }
        }

        setTimeout(function () {

          // if (Enablepreselect && Enablepreselect.trim() !== '') {
          //   const hasPrevSelected = document.querySelector(".la-label-btn-wrapper.la-prev-selected");
          //   if (!hasPrevSelected) {
          //       document.querySelectorAll(".la-label-btn-wrapper").forEach(wrapper => {
          //           const title = wrapper.querySelector(".la-label-title");

          //           if (title && title.textContent.trim().toLowerCase().includes(Enablepreselect)) {
          //               wrapper.classList.add("la-prev-selected");
                        
          //           }
          //       });
          //   }
          // }
          if (Enablepreselect && Enablepreselect.trim() !== '') {
            const hasPrevSelected = document.querySelector(".la-label-btn-wrapper.la-prev-selected");
            if (!hasPrevSelected) {
                const wrappers = document.querySelectorAll(".la-label-btn-wrapper");

                for (const wrapper of wrappers) {
                    const title = wrapper.querySelector(".la-label-title");

                    if (title && title.textContent.trim().toLowerCase().includes(Enablepreselect)) {
                        wrapper.classList.add("la-prev-selected");
                        break;
                    }
                }
            }
          }
      }, 110);
      setTimeout(function(){
        if(EnablePromotion == true){
          const ProductBrand = `cartier, chanel`;
          if(ProductBrand.includes(productVendor)){
            const prescType = document.querySelector(".la-footer-frame-prescription.value1").textContent;
            const lenSType = document.querySelector(".la-footer-frame-prescription.value3").textContent;
            const PrescriptionType = `distance, reading`;
            const PrescriptionlensName = `zeiss`
              if(PrescriptionType.includes(prescType.toLowerCase()) && lenSType == "Clear"){
                const titlewrapper = document.querySelectorAll(".la-label-btn-wrapper")[2];
                  // for (const titlewrapper of labelwrappers) {
                      const wrappertitle = titlewrapper.querySelector(".la-label-title");

                      if (wrappertitle && wrappertitle.textContent.trim().toLowerCase().includes(PrescriptionlensName)) {
                          promotionZeiss = wrappertitle.textContent.trim();
                          const badgeLabel = titlewrapper.querySelector(".la-label-content-box span.hero-badge");
                          setTimeout(function(){
                            const priceLabel = titlewrapper.querySelector(".la-label-price");
                            if (priceLabel) {
                                let price = priceLabel.textContent.trim();

                                // FREE ko remove karo (case-insensitive)
                                price = price.replace(/\bFREE\b/gi, "").trim();

                                // Agar FREE ke baad extra spaces/separators hain
                                price = price.replace(/\s{2,}/g, " ").trim();

                                priceLabel.innerHTML = `
                                    <span style="text-decoration: line-through;">${price}</span>
                                    <span style="color: red; margin-left: 4px;">Free</span>
                                `;
                            }
                            }, 100);
                          badgeLabel.setAttribute("style", "background: #ff00002e;");
                          badgeLabel.innerHTML = `<span style="color: red;">Complimentary 1.5 Single Vision Zeiss Lenses</span>`
                          // break;
                      }
                  // }
              }
          }
        }
      }, 10);
    }   

});

document.addEventListener('LensAdvizor:lensOption1:rendered', function(e) {
document.querySelector(".la-prescription-modal-content-body").classList.remove("la-render-products");
document.querySelector(".la-prescription-modal-content-body").classList.remove("la-render-addons-jtpl");
  const title = document.getElementById('la_prescriptionSelect_title').textContent.trim();
  
  const html = document.getElementById('la_prescriptionSelect_title').innerHTML;
    const div = document.createElement('div');
    div.innerHTML = html;

    const text = [...div.childNodes]
        .filter(node => node.nodeType === Node.TEXT_NODE)
        .map(node => node.textContent.trim())
        .filter(Boolean)[0];

    // console.log(text);

    let cleanedText = text
    .toLowerCase()
    .replace(/\b(choose|your|lens|lenses|chose|additional)\b/g, "")
    .replace(/\s+/g, " ")
    .trim();

    // console.log(cleanedText);
    if(cleanedText == "tint"){
      cleanedText = "Colour"
    } else if(cleanedText.includes('color') || cleanedText.includes('colour')){
      cleanedText = "Colour"
    }

    document.querySelector(".prescription-heading-5").textContent = cleanedText;

        document.querySelectorAll(".la-label-btn-wrapper").forEach(function (el) {
          el.addEventListener("click", function () {
              const text = this.querySelector(".la-label-content-box .la-label-title")?.textContent.trim();
                  document.querySelector(".la-footer-frame-prescription.value5").textContent = text;

                  if(EnableDiscount == false){
                    let OrignalpriceBox;
                     OrignalpriceBox = this.querySelector(".la-label-price").textContent;
                    //  console.log(OrignalpriceBox);
                    if (OrignalpriceBox !== null && OrignalpriceBox !== undefined && OrignalpriceBox !== ""){
                      document.querySelector(".la-footer-frame-prescription.value5").setAttribute("new-price", OrignalpriceBox);
                    }
                  } else{
                   const priceRow = this.querySelector(".la-label-price .price-box");
                    if (priceRow) {
                        document.querySelector(".la-footer-frame-prescription.value5").setAttribute("new-price", priceRow.outerHTML);
                      }
                  }

                  document.querySelector(".prescription-value-5").classList.remove("hide-prescription");
              });
        });

          setInterval(() => {
            const priceText = document
              .querySelector(".la-footer-row.la-subtotal .la-subtotal-price")
              ?.textContent.trim();

            const price = priceText
              ?.replace(/[^\d.]/g, "")
              .replace(".", "");

            const elements = document.querySelectorAll("[data-purchase-amount]");

          if (price) {
            elements.forEach((element) => {
              element.setAttribute("data-purchase-amount", price);
            });
          }
            const klarnaElements = document.querySelectorAll("#wrapper-lensadvisor-jtpl klarna-placement");

        klarnaElements.forEach((klarnaElement) => {
          const shadowRoot = klarnaElement.shadowRoot;

          if (!shadowRoot) return;

          // Style sirf ek baar add hogi har shadowRoot me
          if (!shadowRoot.querySelector("#klarna-custom-style")) {
            const style = document.createElement("style");
            style.id = "klarna-custom-style";
            style.textContent = `
                  .container {
                    flex-direction: row-reverse !important;
                    background: transparent !important;
                    border: 0 !important;
                    padding: 0 !important;
                    justify-content: flex-end !important;
                    position: relative;
                  }
                  .container.order-summary-klarna{
                    justify-content: center !important;
                  }
                  .container button.link {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: auto;
                    font-size: 0;
                  }
                  .container .text-wrapper p.legal{
                    display:none !important;
                  }
                  .container .text-wrapper {
                    margin-left: 0;
                    color: #8a857d;
                    font-size: 12px;
                    line-height: normal;
                    margin-right: 3px;
                  }
                  .container .text-wrapper strong {
                    font-weight: normal;
                  }
                  .container .badge svg {
                    height: 18px;
                    width: 40px;
                    // transform: translateY(1px);
                  }
                  @media (max-width: 1140px) {
                    .container .text-wrapper {
                      font-size: 10px;
                    }
                  }
                  @media (max-width: 994px) {
                    .container .text-wrapper {
                      font-size: 8.5px;
                    }
                  }
                  @media (max-width: 767px) {
                   .desktop-klarna .container {
                      justify-content: center !important;
                    }
                    .container .text-wrapper {
                      font-size: 11px;
                    }
                  }
                `;

                klarnaElement.shadowRoot.appendChild(style);
            }
          });
          }, 10);
          if(submissionMethods == false){
            document.querySelector(".la-progress-bar-step").textContent = "Step 4 of 7";
          } else{
            document.querySelector(".la-progress-bar-step").textContent = "Step 5 of 8";
          }

          if(EnableDescription == true){
            if(cleanedText.includes('Colour')){
              const description7 = `All colours give the same protection — pick the look you love.`;
              document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
                    'afterend', `<p class="la-prescription-description text-center">${description7}</p>`
              );
            } else if(cleanedText.includes('Thickness') || cleanedText.includes('thickness')){
              const description8 = `Thinner lenses look slimmer and feel lighter. Stronger prescriptions benefit most.`;
              document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
                    'afterend', `<p class="la-prescription-description text-center">${description8}</p>`
              );
            } else{
              const description9 = ``;
              document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
                    'afterend', `<p class="la-prescription-description text-center">${description9}</p>`
              );
            }
          }

          if(EnableTitle == true){
            if(cleanedText.includes('Colour')){
              const title7 = `Choose Your Colour for Lenses`;
              if(title7 != ''){
              document.getElementById("la_prescriptionSelect_title").textContent = title7;
              }
            } else if(cleanedText.includes('Thickness') || cleanedText.includes('thickness')){
              const title8 = `Lens Thickness`;
              if(title8 != ''){
              document.getElementById("la_prescriptionSelect_title").textContent = title8;
              }
            } else{
              const title9 = ``;
              if(title9 != ''){
                document.getElementById("la_prescriptionSelect_title").textContent = title9;
              }
            }
          }
          setTimeout(function(){
            if(EnablePromotion == true && cleanedText.includes('Thickness') || cleanedText.includes('thickness')){
              const ProductBrand = `cartier, chanel`;
              if(ProductBrand.includes(productVendor)){
                const prescType = document.querySelector(".la-footer-frame-prescription.value1").textContent;
                const lenSType = document.querySelector(".la-footer-frame-prescription.value3").textContent;
                const lensTitle = document.querySelector(".la-footer-frame-prescription.value4");
                const PrescriptionType = `distance, reading`;
                const PrescriptionlensName = `zeiss`
                  if(PrescriptionType.includes(prescType.toLowerCase()) && lenSType == "Clear"){
                    console.log(".promotionZeiss", promotionZeiss);
                      if (lensTitle.textContent == promotionZeiss) {
                          setTimeout(function(){
                            document.querySelectorAll(".la-label-price")[0].innerHTML =`<span class="free-text" style="color: red;">Free</span>`;
                          }, 80);
                      }
                  }
              }
            }
          }, 10);

          setTimeout(function(){
            if(!cleanedText.includes('Colour')){
              document.querySelectorAll('.la-label-btn-wrapper').forEach(function (btn) {
                  btn.addEventListener('click', function () {
                      const contentWrapper = this.querySelector('.la-label-content-wrapper');
                      if (contentWrapper?.querySelector('.delivery-badge')) {
                          nextDay = true;
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                      }else{
                          nextDay = false;
                          const USEDFOR = document.querySelector(".la-footer-frame-prescription.value1").textContent;
                          const USEDPRES = document.querySelector(".la-footer-frame-prescription.value3").textContent;
                          const LENSPRES = document.querySelector(".la-footer-frame-prescription.value4").textContent;
                          const LENSCOLOUR = document.querySelector(".la-footer-frame-prescription.value5").textContent;
                          
                          if(USEDFOR.includes("Varifocal")){
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                          } else if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
                            document.querySelectorAll(".card-info-wrapper").forEach(function (element) {
                              element.innerHTML = `
                                <div class="dispatch-text">
                                  <p class="dispatch-badge">Dispatch 3-5 Days</p>
                                </div>`;
                              });
                              document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                          } else if(LENSPRES.includes("Ray Ban")){
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                          } else if(LENSPRES.includes("Oakley")){
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                          } else if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror")){
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `5-7 Days`;
                          } else if(USEDFOR.includes("Occupational")){
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                          } else if(USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised")){
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                          } else if(USEDFOR.includes("Ready Reader")){
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `1-3 Days`;
                          } else if(USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                          } else{
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                          }
                            
                      }
                  });
              });
              const USEDFOR = document.querySelector(".la-footer-frame-prescription.value1").textContent;
              const USEDPRES = document.querySelector(".la-footer-frame-prescription.value3").textContent;
              const LENSPRES = document.querySelector(".la-footer-frame-prescription.value4").textContent;
              const LENSCOLOUR = document.querySelector(".la-footer-frame-prescription.value5").textContent;

                if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror") || USEDFOR.includes("Varifocal") || USEDFOR.includes("Occupational") || USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised") || USEDFOR.includes("Ready Reader") || USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                    nextDay = false;
                }
                if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
                  nextDay = false;
                }

              if(nextDay == false){
                document.querySelectorAll('.la-label-btn-wrapper').forEach(function (btn) {
                    const delvbadge = btn.querySelector('.delivery-badge');
                    if (delvbadge) {
                        delvbadge.remove();
                          if(USEDFOR.includes("Varifocal")){
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                          } else if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
                            document.querySelectorAll(".card-info-wrapper").forEach(function (element) {
                              element.innerHTML = `
                                <div class="dispatch-text">
                                  <p class="dispatch-badge">Dispatch 3-5 Days</p>
                                </div>`;
                              });
                              document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                          } else if(LENSPRES.includes("Ray Ban")){
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;  
                          } else if(LENSPRES.includes("Oakley")){
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                          } else if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror")){
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `5-7 Days`;
                          } else if(USEDFOR.includes("Occupational")){
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                          } else if(USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised")){
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                          } else if(USEDFOR.includes("Ready Reader")){
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `1-3 Days`;
                          } else if(USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                          } else{
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                          }
                    }
                    if(USEDFOR.includes("Varifocal")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                    } else if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
                      document.querySelectorAll(".card-info-wrapper").forEach(function (element) {
                        element.innerHTML = `
                          <div class="dispatch-text">
                            <p class="dispatch-badge">Dispatch 3-5 Days</p>
                          </div>`;
                        });
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                    } else if(LENSPRES.includes("Ray Ban")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;  
                    } else if(LENSPRES.includes("Oakley")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                    } else if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `5-7 Days`;
                    } else if(USEDFOR.includes("Occupational")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                    } else if(USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                    } else if(USEDFOR.includes("Ready Reader")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `1-3 Days`;
                    } else if(USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                    } else{
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                    }
                });
              }else{
                document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
              }
            }
          }, 10);
});

document.addEventListener('LensAdvizor:lensOption2:rendered', function(e) {
   document.querySelector(".la-prescription-modal-content-body").classList.remove("la-render-addons-jtpl");
  const html = document.getElementById('la_prescriptionSelect_title').innerHTML;
    const div = document.createElement('div');
    div.innerHTML = html;

    const text = [...div.childNodes]
        .filter(node => node.nodeType === Node.TEXT_NODE)
        .map(node => node.textContent.trim())
        .filter(Boolean)[0];

    // console.log(text);

    let cleanedText = text
    .toLowerCase()
    .replace(/\b(choose|your|lens|lenses|chose|additional)\b/g, "")
    .replace(/\s+/g, " ")
    .trim();

    // console.log(cleanedText);
    if(cleanedText == "tint"){
      cleanedText = "Colour"
    } else if(cleanedText.includes('color') || cleanedText.includes('colour')){
      cleanedText = "Colour"
    }

    document.querySelector(".prescription-heading-6").textContent = cleanedText;

    document.querySelectorAll(".la-label-btn-wrapper").forEach(function (el) {
      el.addEventListener("click", function () {
          const text = this.querySelector(".la-label-content-box .la-label-title")?.textContent.trim();
              document.querySelector(".la-footer-frame-prescription.value6").textContent = text;

              if(EnableDiscount == false){
                let OrignalpriceBox;
                     OrignalpriceBox = this.querySelector(".la-label-price").textContent;
                    //  console.log(OrignalpriceBox);
                    if (OrignalpriceBox !== null && OrignalpriceBox !== undefined && OrignalpriceBox !== ""){
                      document.querySelector(".la-footer-frame-prescription.value6").setAttribute("new-price", OrignalpriceBox);
                    }
              } else{
                const priceRow = this.querySelector(".la-label-price .price-box");
                if (priceRow) {
                  document.querySelector(".la-footer-frame-prescription.value6").setAttribute("new-price", priceRow.outerHTML);
                }
              }

              document.querySelector(".prescription-value-6").classList.remove("hide-prescription");
          });
    });

      setInterval(() => {
        const priceText = document
          .querySelector(".la-footer-row.la-subtotal .la-subtotal-price")
          ?.textContent.trim();

        const price = priceText
          ?.replace(/[^\d.]/g, "")
          .replace(".", "");

        const elements = document.querySelectorAll("[data-purchase-amount]");

          if (price) {
            elements.forEach((element) => {
              element.setAttribute("data-purchase-amount", price);
            });
          }
        const klarnaElements = document.querySelectorAll("#wrapper-lensadvisor-jtpl klarna-placement");

        klarnaElements.forEach((klarnaElement) => {
          const shadowRoot = klarnaElement.shadowRoot;

          if (!shadowRoot) return;

          // Style sirf ek baar add hogi har shadowRoot me
          if (!shadowRoot.querySelector("#klarna-custom-style")) {
            const style = document.createElement("style");
            style.id = "klarna-custom-style";
            style.textContent = `
                  .container {
                    flex-direction: row-reverse !important;
                    background: transparent !important;
                    border: 0 !important;
                    padding: 0 !important;
                    justify-content: flex-end !important;
                    position: relative;
                  }
                  .container.order-summary-klarna{
                    justify-content: center !important;
                  }
                  .container button.link {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: auto;
                    font-size: 0;
                  }
                  .container .text-wrapper p.legal{
                    display:none !important;
                  }
                  .container .text-wrapper {
                    margin-left: 0;
                    color: #8a857d;
                    font-size: 12px;
                    line-height: normal;
                    margin-right: 3px;
                  }
                  .container .text-wrapper strong {
                    font-weight: normal;
                  }
                  .container .badge svg {
                    height: 18px;
                    width: 40px;
                    // transform: translateY(1px);
                  }
                  @media (max-width: 1140px) {
                    .container .text-wrapper {
                      font-size: 10px;
                    }
                  }
                  @media (max-width: 994px) {
                    .container .text-wrapper {
                      font-size: 8.5px;
                    }
                  }
                  @media (max-width: 767px) {
                   .desktop-klarna .container {
                      justify-content: center !important;
                    }
                    .container .text-wrapper {
                      font-size: 11px;
                    }
                  }
                `;

                klarnaElement.shadowRoot.appendChild(style);
            }
          });
      }, 10);
      if(submissionMethods == false){
         document.querySelector(".la-progress-bar-step").textContent = "Step 5 of 7";
      } else{
         document.querySelector(".la-progress-bar-step").textContent = "Step 6 of 8";
      }

      if(EnableDescription == true){
        if(cleanedText.includes('Colour')){
          const description7 = `All colours give the same protection — pick the look you love.`;
          document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
                'afterend', `<p class="la-prescription-description text-center">${description7}</p>`
          );
        } else if(cleanedText.includes('Thickness') || cleanedText.includes('thickness')){
          const description8 = `Thinner lenses look slimmer and feel lighter. Stronger prescriptions benefit most.`;
          document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
                'afterend', `<p class="la-prescription-description text-center">${description8}</p>`
          );
        } else{
          const description9 = ``;
          document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
                'afterend', `<p class="la-prescription-description text-center">${description9}</p>`
          );
        }
      }

      if(EnableTitle == true){
        if(cleanedText.includes('Colour')){
          const title7 = `Choose Your Colour for Lenses`;
          if(title7 != ''){
          document.getElementById("la_prescriptionSelect_title").textContent = title7;
          }
        } else if(cleanedText.includes('Thickness') || cleanedText.includes('thickness')){
          const title8 = `Lens Thickness`;
          if(title8 != ''){
          document.getElementById("la_prescriptionSelect_title").textContent = title8;
          }
        } else{
          const title9 = ``;
          if(title9 != ''){
            document.getElementById("la_prescriptionSelect_title").textContent = title9;
          }
        }
      }
      setTimeout(function(){
        if(EnablePromotion == true && cleanedText.includes('Thickness') || cleanedText.includes('thickness')){
          const ProductBrand = `cartier, chanel`;
          if(ProductBrand.includes(productVendor)){
            const prescType = document.querySelector(".la-footer-frame-prescription.value1").textContent;
            const lenSType = document.querySelector(".la-footer-frame-prescription.value3").textContent;
            const lensTitle = document.querySelector(".la-footer-frame-prescription.value4");
            const PrescriptionType = `distance, reading`;
            const PrescriptionlensName = `zeiss`
              if(PrescriptionType.includes(prescType.toLowerCase()) && lenSType == "Clear"){
                console.log(".promotionZeiss", promotionZeiss);
                  if (lensTitle.textContent == promotionZeiss) {
                      setTimeout(function(){
                        document.querySelectorAll(".la-label-price")[0].innerHTML =`<span class="free-text" style="color: red;">Free</span>`;
                      }, 80);
                  }
              }
          }
        }
      }, 10);

      setTimeout(function(){
        if(!cleanedText.includes('Colour')){
            document.querySelectorAll('.la-label-btn-wrapper').forEach(function (btn) {
                btn.addEventListener('click', function () {
                    const contentWrapper = this.querySelector('.la-label-content-wrapper');
                    if (contentWrapper?.querySelector('.delivery-badge')) {
                        nextDay = true;
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                    }else{
                        nextDay = false;
                        const USEDFOR = document.querySelector(".la-footer-frame-prescription.value1").textContent;
                        const USEDPRES = document.querySelector(".la-footer-frame-prescription.value3").textContent;
                        const LENSPRES = document.querySelector(".la-footer-frame-prescription.value4").textContent;
                        const LENSCOLOUR = document.querySelector(".la-footer-frame-prescription.value5").textContent;

                        if(USEDFOR.includes("Varifocal")){
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                        } else if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
                          document.querySelectorAll(".card-info-wrapper").forEach(function (element) {
                            element.innerHTML = `
                              <div class="dispatch-text">
                                <p class="dispatch-badge">Dispatch 3-5 Days</p>
                              </div>`;
                            });
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                        } else if(LENSPRES.includes("Ray Ban")){
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;  
                        } else if(LENSPRES.includes("Oakley")){
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                        } else if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror")){
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `5-7 Days`;
                        } else if(USEDFOR.includes("Occupational")){
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                        } else if(USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised")){
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                        } else if(USEDFOR.includes("Ready Reader")){
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `1-3 Days`;
                        } else if(USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                        } else{
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                        }
                          
                    }
                });
            });
            const USEDFOR = document.querySelector(".la-footer-frame-prescription.value1").textContent;
            const USEDPRES = document.querySelector(".la-footer-frame-prescription.value3").textContent;
            const LENSPRES = document.querySelector(".la-footer-frame-prescription.value4").textContent;
            const LENSCOLOUR = document.querySelector(".la-footer-frame-prescription.value5").textContent;

              if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror") || USEDFOR.includes("Varifocal") || USEDFOR.includes("Occupational") || USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised") || USEDFOR.includes("Ready Reader") || USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                  nextDay = false;
              }
              if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
                nextDay = false;
              }

            if(nextDay == false){
              document.querySelectorAll('.la-label-btn-wrapper').forEach(function (btn) {
                  const delvbadge = btn.querySelector('.delivery-badge');
                  if (delvbadge) {
                      delvbadge.remove();
                        if(USEDFOR.includes("Varifocal")){
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                        } else if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
                          document.querySelectorAll(".card-info-wrapper").forEach(function (element) {
                            element.innerHTML = `
                              <div class="dispatch-text">
                                <p class="dispatch-badge">Dispatch 3-5 Days</p>
                              </div>`;
                            });
                            document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                        } else if(LENSPRES.includes("Ray Ban")){
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                        } else if(LENSPRES.includes("Oakley")){
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                        } else if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror")){
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `5-7 Days`;
                        } else if(USEDFOR.includes("Occupational")){
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                        } else if(USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised")){
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                        } else if(USEDFOR.includes("Ready Reader")){
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `1-3 Days`;
                        } else if(USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                        } else{
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                        }
                  }
                  if(USEDFOR.includes("Varifocal")){
                    document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                  } else if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
                    document.querySelectorAll(".card-info-wrapper").forEach(function (element) {
                      element.innerHTML = `
                        <div class="dispatch-text">
                          <p class="dispatch-badge">Dispatch 3-5 Days</p>
                        </div>`;
                      });
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                  } else if(LENSPRES.includes("Ray Ban")){
                    document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;  
                  } else if(LENSPRES.includes("Oakley")){
                    document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                  } else if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror")){
                    document.querySelector(".la-footer-frame-prescription.value9").textContent = `5-7 Days`;
                  } else if(USEDFOR.includes("Occupational")){
                    document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                  } else if(USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised")){
                    document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                  } else if(USEDFOR.includes("Ready Reader")){
                    document.querySelector(".la-footer-frame-prescription.value9").textContent = `1-3 Days`;
                  } else if(USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                    document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                  } else{
                    document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                  }
              });
            }else{
              document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
            }
        }
      }, 10);

});

document.addEventListener('LensAdvizor:lensOption3:rendered', function(e) {

  const html = document.getElementById('la_prescriptionSelect_title').innerHTML;
    const div = document.createElement('div');
    div.innerHTML = html;

    const text = [...div.childNodes]
        .filter(node => node.nodeType === Node.TEXT_NODE)
        .map(node => node.textContent.trim())
        .filter(Boolean)[0];

    // console.log(text);

    let cleanedText = text
    .toLowerCase()
    .replace(/\b(choose|your|lens|lenses|chose|additional)\b/g, "")
    .replace(/\s+/g, " ")
    .trim();

    // console.log(cleanedText);
    if(cleanedText == "tint"){
      cleanedText = "Colour"
    } else if(cleanedText.includes('color') || cleanedText.includes('colour')){
      cleanedText = "Colour"
    }

  document.querySelector(".prescription-heading-7").textContent = cleanedText;

    document.querySelectorAll(".la-label-btn-wrapper").forEach(function (el) {
      el.addEventListener("click", function () {
          const text = this.querySelector(".la-label-content-box .la-label-title")?.textContent.trim();
              document.querySelector(".la-footer-frame-prescription.value7").textContent = text;

              if(EnableDiscount == false){
                let OrignalpriceBox;
                     OrignalpriceBox = this.querySelector(".la-label-price").textContent;
                    //  console.log(OrignalpriceBox);
                    if (OrignalpriceBox !== null && OrignalpriceBox !== undefined && OrignalpriceBox !== ""){
                      document.querySelector(".la-footer-frame-prescription.value7").setAttribute("new-price", OrignalpriceBox);
                    }
              } else{
                const priceRow = this.querySelector(".la-label-price .price-box");
                if (priceRow) {
                  document.querySelector(".la-footer-frame-prescription.value7").setAttribute("new-price", priceRow.outerHTML);
                }
              }
              document.querySelector(".prescription-value-7").classList.remove("hide-prescription");
          });
    });

      setInterval(() => {
        const priceText = document
          .querySelector(".la-footer-row.la-subtotal .la-subtotal-price")
          ?.textContent.trim();

        const price = priceText
          ?.replace(/[^\d.]/g, "")
          .replace(".", "");

        const elements = document.querySelectorAll("[data-purchase-amount]");

          if (price) {
            elements.forEach((element) => {
              element.setAttribute("data-purchase-amount", price);
            });
          }
        const klarnaElements = document.querySelectorAll("#wrapper-lensadvisor-jtpl klarna-placement");

        klarnaElements.forEach((klarnaElement) => {
          const shadowRoot = klarnaElement.shadowRoot;

          if (!shadowRoot) return;

          // Style sirf ek baar add hogi har shadowRoot me
          if (!shadowRoot.querySelector("#klarna-custom-style")) {
            const style = document.createElement("style");
            style.id = "klarna-custom-style";
            style.textContent = `
                  .container {
                    flex-direction: row-reverse !important;
                    background: transparent !important;
                    border: 0 !important;
                    padding: 0 !important;
                    justify-content: flex-end !important;
                    position: relative;
                  }
                  .container.order-summary-klarna{
                    justify-content: center !important;
                  }
                  .container button.link {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: auto;
                    font-size: 0;
                  }
                  .container .text-wrapper p.legal{
                    display:none !important;
                  }
                  .container .text-wrapper {
                    margin-left: 0;
                    color: #8a857d;
                    font-size: 12px;
                    line-height: normal;
                    margin-right: 3px;
                  }
                  .container .text-wrapper strong {
                    font-weight: normal;
                  }
                  .container .badge svg {
                    height: 18px;
                    width: 40px;
                    // transform: translateY(1px);
                  }
                  @media (max-width: 1140px) {
                    .container .text-wrapper {
                      font-size: 10px;
                    }
                  }
                  @media (max-width: 994px) {
                    .container .text-wrapper {
                      font-size: 8.5px;
                    }
                  }
                  @media (max-width: 767px) {
                   .desktop-klarna .container {
                      justify-content: center !important;
                    }
                    .container .text-wrapper {
                      font-size: 11px;
                    }
                  }
                `;

                klarnaElement.shadowRoot.appendChild(style);
            }
          });
      }, 10);
      if(submissionMethods == false){
        document.querySelector(".la-progress-bar-step").textContent = "Step 6 of 7";
      } else{
        document.querySelector(".la-progress-bar-step").textContent = "Step 7 of 8";
      }

      if(EnableDescription == true){
        if(cleanedText.includes('Colour')){
          const description7 = `All colours give the same protection — pick the look you love.`;
          document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
                'afterend', `<p class="la-prescription-description text-center">${description7}</p>`
          );
        } else if(cleanedText.includes('Thickness') || cleanedText.includes('thickness')){
          const description8 = `Thinner lenses look slimmer and feel lighter. Stronger prescriptions benefit most.`;
          document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
                'afterend', `<p class="la-prescription-description text-center">${description8}</p>`
          );
        } else{
          const description9 = ``;
          document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
                'afterend', `<p class="la-prescription-description text-center">${description9}</p>`
          );
        }
      }

      if(EnableTitle == true){
        if(cleanedText.includes('Colour')){
          const title7 = `Choose Your Colour for Lenses`;
          if(title7 != ''){
          document.getElementById("la_prescriptionSelect_title").textContent = title7;
          }
        } else if(cleanedText.includes('Thickness') || cleanedText.includes('thickness')){
          const title8 = `Lens Thickness`;
          if(title8 != ''){
          document.getElementById("la_prescriptionSelect_title").textContent = title8;
          }
        } else{
          const title9 = ``;
          if(title9 != ''){
            document.getElementById("la_prescriptionSelect_title").textContent = title9;
          }
        }
      }
      setTimeout(function(){
        if(EnablePromotion == true && cleanedText.includes('Thickness') || cleanedText.includes('thickness')){
          const ProductBrand = `cartier, chanel`;
          if(ProductBrand.includes(productVendor)){
            const prescType = document.querySelector(".la-footer-frame-prescription.value1").textContent;
            const lenSType = document.querySelector(".la-footer-frame-prescription.value3").textContent;
            const lensTitle = document.querySelector(".la-footer-frame-prescription.value4");
            const PrescriptionType = `distance, reading`;
            const PrescriptionlensName = `zeiss`
              if(PrescriptionType.includes(prescType.toLowerCase()) && lenSType == "Clear"){
                console.log(".promotionZeiss", promotionZeiss);
                  if (lensTitle.textContent == promotionZeiss) {
                      setTimeout(function(){
                        document.querySelectorAll(".la-label-price")[0].innerHTML =`<span class="free-text" style="color: red;">Free</span>`;
                      }, 80);
                  }
              }
          }
        }
      }, 10);

      setTimeout(function(){
        if(!cleanedText.includes('Colour')){
            document.querySelectorAll('.la-label-btn-wrapper').forEach(function (btn) {
              btn.addEventListener('click', function () {
                  const contentWrapper = this.querySelector('.la-label-content-wrapper');
                  if (contentWrapper?.querySelector('.delivery-badge')) {
                      nextDay = true;
                      document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                  }else{
                      nextDay = false;
                      const USEDFOR = document.querySelector(".la-footer-frame-prescription.value1").textContent;
                      const USEDPRES = document.querySelector(".la-footer-frame-prescription.value3").textContent;
                      const LENSPRES = document.querySelector(".la-footer-frame-prescription.value4").textContent;
                      const LENSCOLOUR = document.querySelector(".la-footer-frame-prescription.value5").textContent;

                      if(USEDFOR.includes("Varifocal")){
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                      } else if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
                        document.querySelectorAll(".card-info-wrapper").forEach(function (element) {
                          element.innerHTML = `
                            <div class="dispatch-text">
                              <p class="dispatch-badge">Dispatch 3-5 Days</p>
                            </div>`;
                          });
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                      } else if(LENSPRES.includes("Ray Ban")){
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;  
                      } else if(LENSPRES.includes("Oakley")){
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                      } else if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror")){
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `5-7 Days`;
                      } else if(USEDFOR.includes("Occupational")){
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                      } else if(USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised")){
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                      } else if(USEDFOR.includes("Ready Reader")){
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `1-3 Days`;
                      } else if(USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                      } else{
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                      }
                        
                  }
              });
          });
          const USEDFOR = document.querySelector(".la-footer-frame-prescription.value1").textContent;
          const USEDPRES = document.querySelector(".la-footer-frame-prescription.value3").textContent;
          const LENSPRES = document.querySelector(".la-footer-frame-prescription.value4").textContent;
          const LENSCOLOUR = document.querySelector(".la-footer-frame-prescription.value5").textContent;
          
            if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror") || USEDFOR.includes("Varifocal") || USEDFOR.includes("Occupational") || USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised") || USEDFOR.includes("Ready Reader") || USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                nextDay = false;
            }
            if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
              nextDay = false;
            }

          if(nextDay == false){
            document.querySelectorAll('.la-label-btn-wrapper').forEach(function (btn) {
                const delvbadge = btn.querySelector('.delivery-badge');
                if (delvbadge) {
                    delvbadge.remove();
                      if(USEDFOR.includes("Varifocal")){
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                      } else if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
                        document.querySelectorAll(".card-info-wrapper").forEach(function (element) {
                          element.innerHTML = `
                            <div class="dispatch-text">
                              <p class="dispatch-badge">Dispatch 3-5 Days</p>
                            </div>`;
                          });
                          document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                      } else if(LENSPRES.includes("Ray Ban")){
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                      } else if(LENSPRES.includes("Oakley")){
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                      } else if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror")){
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `5-7 Days`;
                      } else if(USEDFOR.includes("Occupational")){
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                      } else if(USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised")){
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                      } else if(USEDFOR.includes("Ready Reader")){
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `1-3 Days`;
                      } else if(USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                      } else{
                        document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                      }
                }
                if(USEDFOR.includes("Varifocal")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                } else if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
                  document.querySelectorAll(".card-info-wrapper").forEach(function (element) {
                    element.innerHTML = `
                      <div class="dispatch-text">
                        <p class="dispatch-badge">Dispatch 3-5 Days</p>
                      </div>`;
                    });
                    document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                } else if(LENSPRES.includes("Ray Ban")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                } else if(LENSPRES.includes("Oakley")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                } else if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `5-7 Days`;
                } else if(USEDFOR.includes("Occupational")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                } else if(USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                } else if(USEDFOR.includes("Ready Reader")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `1-3 Days`;
                } else if(USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                } else{
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                }
            });
          }else{
            document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
          }
        }
      }, 10);

});
// document.addEventListener('LensAdvizor:addOns:rendered', function(e) {

// setTimeout(() => {
//   const SkipButton = document.querySelector(".la-skip-add-on-wrapper");
//   if(SkipButton){
//     SkipButton.insertAdjacentHTML('beforebegin', `<div class="add-on-selector text-center">None selected</div>`);
//   }
//   document.querySelectorAll(".la-label-btn-wrapper").forEach(function (item) {
//     const input = item.querySelector("input");

//     item.classList.toggle("la-prev-selected", input && input.checked);
//     if(input && input.checked){
//       document.querySelector(".prescription-value-8").classList.remove("hide-prescription"); 
//       let totalPrice = 0;
//                   let totalAdded = 0;       
//                   document.querySelectorAll(".la-label-btn-wrapper").forEach(function (item) {
//                       const input = item.querySelector('input[type="checkbox"], input[type="radio"]');
//                       if (input && input.checked) {
//                           totalAdded++;
//                           let priceEl = 0;
//                           if(EnableDiscount == true){
//                             priceEl = item.querySelector(".new-price"); 
//                            } else{
//                             priceEl = item.querySelector(".la-label-price"); 
//                            }
//                           if (priceEl) {
//                               const price = parseFloat(
//                                   priceEl.textContent.replace(/[^0-9.-]+/g, "")
//                               ) || 0;
//                               totalPrice += price;
//                           }
//                       }
//                   });
                  
//                   let currency = "";
//                   let firstPrice = 0;
//                   if(EnableDiscount == true){
//                   firstPrice = document.querySelector(".la-label-btn-wrapper .new-price");
//                   } else{
//                     firstPrice = document.querySelector(".la-label-btn-wrapper .la-label-price");
//                   }
//                   if (firstPrice) {
//                       const match = firstPrice.textContent.trim().match(/^[^\d-]+/);
//                       currency = match ? match[0] : "";
//                   }
//                   const addOnSelector = document.querySelector(".add-on-selector");
//                     const prescriptionValue = document.querySelector(".prescription-value-8");

//                     if (addOnSelector) {
//                         if (totalAdded === 0) {
//                             addOnSelector.textContent = "None selected";
//                             addOnSelector.classList.remove("add-on-added");
//                         } else {
//                             addOnSelector.textContent = `${totalAdded} added · +${currency}${totalPrice.toFixed(2)}`;
//                             addOnSelector.classList.add("add-on-added");
//                         }
//                     }

//                     if (prescriptionValue && totalAdded === 0) {
//                         prescriptionValue.classList.add("hide-prescription");
//                     }
//     }
// });

// const addonTitles = [
//   `Do you use computers and screens a lot? Add a blue-light coating.`,
//   `Accidental damage cover for scratches or breakage.`,
//   ``
// ];

// document.querySelectorAll(".la-label-btn-wrapper").forEach(function (item, index) {
//   const title = addonTitles[index];

//   if (title && !item.querySelector(".addon-title")) {
//     item.insertAdjacentHTML(
//       "afterbegin",
//       `<div class="addon-title">${title}</div>`
//     );     
//   }
// });
// const wrappers = document.querySelectorAll(".la-label-btn-wrapper .addon-title");
// console.log(wrappers);
// const titleToShow =
//   wrappers.length === 1
//     ? addonTitles[1]
//     : null;
//     console.log(titleToShow);
// if(titleToShow !== null){
// document.querySelector(".la-label-btn-wrapper .addon-title").textContent = titleToShow;

// }

// }, 30);

//   const html = document.getElementById('la_prescriptionSelect_title').innerHTML;
//     const div = document.createElement('div');
//     div.innerHTML = html;

//     const text = [...div.childNodes]
//         .filter(node => node.nodeType === Node.TEXT_NODE)
//         .map(node => node.textContent.trim())
//         .filter(Boolean)[0];

//     // console.log(text);

//     let cleanedText = text
//     .toLowerCase()
//     .replace(/\b(choose|your|lens|lenses|chose|additional)\b/g, "")
//     .replace(/\s+/g, " ")
//     .trim();

//     // console.log(cleanedText);
//     if(cleanedText == "tint"){
//       cleanedText = "Colour"
//     } else if(cleanedText.includes('color') || cleanedText.includes('colour')){
//       cleanedText = "Colour"
//     }

//   document.querySelector(".prescription-heading-8").textContent = cleanedText;

//     document.querySelectorAll(".la-label-btn-wrapper").forEach(function (el) {
//       el.addEventListener("click", function () {

//         const titles = [];
//         document.querySelectorAll(".la-label-btn-wrapper").forEach(function (item) {
//             const input = item.querySelector("input");

//             if (input && input.checked) {
//                 const title = item.querySelector(".la-label-content-box .la-label-title")?.textContent.trim();
//                 if (title) {
//                     titles.push(title);
//                 }
//             }
            
//         });

//         document.querySelector(".la-footer-frame-prescription.value8").innerHTML = titles.join("<br>");
//           // const text = this.querySelector(".la-label-content-box .la-label-title")?.textContent.trim();
//           //     document.querySelector(".la-footer-frame-prescription.value8").textContent = text;

//               const inputVal = this.querySelector("input").value;
//               document.querySelector(".la-footer-frame-prescription.value8").setAttribute("addOn", inputVal);

//               // if(EnableDiscount == false){
//               //   let OrignalpriceBox;
//               //        OrignalpriceBox = this.querySelector(".la-label-price").textContent;
//               //        console.log(OrignalpriceBox);
//               //       if (OrignalpriceBox !== null && OrignalpriceBox !== undefined && OrignalpriceBox !== ""){
//               //         document.querySelector(".la-footer-frame-prescription.value8").setAttribute("new-price", OrignalpriceBox);
//               //       }
//               // } else{
//               //   const priceRow = this.querySelector(".la-label-price .price-box");
//               //   if (priceRow) {
//               //     document.querySelector(".la-footer-frame-prescription.value8").setAttribute("new-price", priceRow.outerHTML);
//               //   }
//               // }
              
//               document.querySelector(".prescription-value-8").classList.remove("hide-prescription");   

//               setTimeout(() => {  

//                 //************************   Add-on selection text when add-on select   *******************************/

//                   let totalPrice = 0;
//                   let totalAdded = 0;       
//                   document.querySelectorAll(".la-label-btn-wrapper").forEach(function (item) {
//                       const input = item.querySelector('input[type="checkbox"], input[type="radio"]');
//                       if (input && input.checked) {
//                           totalAdded++;
//                           let priceEl = 0;
//                           if(EnableDiscount == true){
//                             priceEl = item.querySelector(".new-price"); 
//                            } else{
//                             priceEl = item.querySelector(".la-label-price"); 
//                            }
//                           if (priceEl) {
//                               const price = parseFloat(
//                                   priceEl.textContent.replace(/[^0-9.-]+/g, "")
//                               ) || 0;
//                               totalPrice += price;
//                           }
//                       }
//                   });
                  
//                   let currency = "";
//                   let firstPrice = 0;
//                   if(EnableDiscount == true){
//                   firstPrice = document.querySelector(".la-label-btn-wrapper .new-price");
//                   } else{
//                     firstPrice = document.querySelector(".la-label-btn-wrapper .la-label-price");
//                   }
//                   if (firstPrice) {
//                       const match = firstPrice.textContent.trim().match(/^[^\d-]+/);
//                       currency = match ? match[0] : "";
//                   }
//                   if(totalAdded == 0){
//                     document.querySelector(".add-on-selector").textContent = `None selected`;
//                     document.querySelector(".prescription-value-8").classList.add("hide-prescription");
//                     document.querySelector(".add-on-selector").classList.remove("add-on-added");
//                   } else{
//                      document.querySelector(".add-on-selector").classList.add("add-on-added");
//                     document.querySelector(".add-on-selector").textContent = `${totalAdded} added · +${currency}${totalPrice.toFixed(2)}`;
//                   }

//                   //************************   Add-on selection text when add-on end   *******************************/

//                   var discount = false;
//                   if(discount == true){

//                   //************************    LensPrices with discount when add-on select   *******************************/ 

//                     document.querySelectorAll('.la-footer-row').forEach(function (row) {

//                       const symbolEl = row.querySelector('.currency-symbol');
//                       const priceEl = row.querySelector('.la-footer-lens-price');

//                       if (!symbolEl || !priceEl) return; // Element nahi mila to skip

//                       const symbol = symbolEl.textContent.trim();
//                       const price = parseFloat(priceEl.textContent.trim());

//                       if (isNaN(price)) return;

//                       const discount = `25`;
//                       const discountedPrice = (price * (100 - discount) / 100).toFixed(2);

//                       var disamount = price.toFixed(2) - discountedPrice;
//                       document.querySelector(".discount-ammount").textContent = `- ${symbol}${disamount.toFixed(2)}`;
//                       document.querySelector(".discount-ammount").setAttribute("data-price", disamount.toFixed(2));

//                       const parentLabel = document.querySelector(".la-choose-prescription-wrapper");
//                       if (parentLabel && parentLabel.classList.contains("la-render-review")) {
//                           document.querySelector(".lens-discount-price").textContent = `- ${symbol}${disamount.toFixed(2)}`;
//                       }

//                       priceEl.innerHTML = `
//                         <div class="lenses-discount-price">
//                           <span class="old-price">
//                               ${symbol}${price.toFixed(2)}
//                           </span>
//                           <span class="final-price">
//                               ${symbol}${discountedPrice}
//                           </span>
//                         </div>
//                       `;
//                     }); 

//                     //************************    LensPrices with discount when add-on end   *******************************/  
                    
//                     //************************    Add-On Prices with discount when add-on select    *******************************/ 

//                     const addonPriceEl = document.querySelectorAll(".la-footer-addon-price");
//                     addonPriceEl.forEach(function (addonPriceEl) {

//                         // Already discounted? Skip this element
//                         if (addonPriceEl.querySelector(".lenses-discount-price")) {
//                             return;
//                         }

//                         const discountAmountEl = document.querySelector(".discount-ammount");

//                         if (addonPriceEl) {
//                             const Priceaddon = addonPriceEl.textContent;
//                             const currencySymbol = document.body.getAttribute("theme-currency");

//                             let addonPrice = parseFloat(
//                                 addonPriceEl.textContent.replace(/[^\d.]/g, "")
//                             );

//                             const discountt = Number(`25`);

//                             let finalPrice = addonPrice - (addonPrice * (discountt / 100));

//                             if (finalPrice > 0) {

//                                 const addonDiscount = addonPrice - finalPrice;

//                                 if (discountAmountEl) {
//                                     let existingDiscount = parseFloat(
//                                         discountAmountEl.textContent.replace(/[^\d.]/g, "")
//                                     );

//                                     let totalDiscount = existingDiscount + addonDiscount;

//                                     discountAmountEl.textContent = `- ${currencySymbol}${totalDiscount.toFixed(2)}`;
//                                     discountAmountEl.setAttribute("data-price", totalDiscount.toFixed(2));

//                                     const parentLabel = document.querySelector(".la-choose-prescription-wrapper");
//                                     if (parentLabel && parentLabel.classList.contains("la-render-review")) {
//                                         document.querySelector(".lens-discount-price").textContent =
//                                             `- ${currencySymbol}${totalDiscount.toFixed(2)}`;
//                                     }
//                                 }

//                                 addonPriceEl.innerHTML = `
//                                     <div class="lenses-discount-price">
//                                         <span class="old-price">${Priceaddon}</span>
//                                         <span class="final-price">
//                                             ${currencySymbol}${finalPrice.toFixed(2)}
//                                         </span>
//                                     </div>
//                                 `;
//                             }
//                         }
//                     });
//                     //************************    Add-On Prices with discount when add-on select end   *******************************/ 
//                   }

//                   //**********************  Add-on sum  ***************************/
//                       var discount = false;
//                       let total = 0;
//                       if(discount == true){
//                         const oldPrices = document.querySelectorAll(".la-footer-addon-price span.old-price");
//                             oldPrices.forEach(el => {
//                                 const text = el.textContent.trim();

//                                 const price = parseFloat(text.replace(/[^0-9.]/g, ""));

//                                 if (!isNaN(price)) {
//                                     total += price;
//                                 }
//                             });
//                       } else{
//                         const oldPrices = document.querySelectorAll(".la-footer-addon-price");
//                             oldPrices.forEach(el => {
//                                 const text = el.textContent.trim();

//                                 const price = parseFloat(text.replace(/[^0-9.]/g, ""));

//                                 if (!isNaN(price)) {
//                                     total += price;
//                                 }
//                             });
//                       }
                        
//                         const totalDiv = document.createElement("div");
//                         totalDiv.className = "la-addon-price";
//                         // totalDiv.textContent = `${Symbolcurrency}${total.toFixed(2)}`;

                        
//                         const container = document.querySelector(".la-footer-addon-wrapper");
//                         if (container) {
//                           // if exist then remove
//                           container.querySelector(".la-addon-price")?.remove();

//                           const totalDiv = document.createElement("div");
//                           totalDiv.className = "la-addon-price";

                          
//                           if(discount == true){
//                             const discounttt = `25`;
//                             const discountedPricee = (total.toFixed(2) * (100 - discounttt) / 100).toFixed(2);
                            
//                             totalDiv.innerHTML = `
//                                     <div class="la-addon-discount-price">
//                                         <span class="old-price">${Symbolcurrency}${total.toFixed(2)}</span>
//                                         <span class="final-price">
//                                             ${Symbolcurrency}${discountedPricee}
//                                         </span>
//                                     </div>
//                                 `;

//                           }else{
//                             totalDiv.textContent = `${Symbolcurrency}${total.toFixed(2)}`;
//                           }

//                           container.insertAdjacentElement("afterbegin", totalDiv);
//                       }
//                   //************************ Add-on Sum  ***************************/  
                
//               const addOnprices = document.querySelector(".la-addon-price").innerHTML;
//               document.querySelector(".la-footer-frame-prescription.value8").setAttribute("new-price", addOnprices);

//               }, 0);
//           });
//     });

//     var SumAddOntitle = document.querySelector(".la-footer-frame-prescription.value8").textContent;
//     document.querySelectorAll(".la-label-content-box .la-label-title").forEach(function (el) {
//       var AddOntitle = el.textContent.trim();
//       if(SumAddOntitle === AddOntitle){
//         const parent = el.closest('.la-label-btn-wrapper');
//         if (parent) {
//             setTimeout(function(){
//              parent.classList.add('la-prev-selected');
//             }, 50);
//         }
//       }
//     });


//       setInterval(() => {
//         const priceText = document
//           .querySelector(".la-footer-row.la-subtotal .la-subtotal-price")
//           ?.textContent.trim();

//         const price = priceText
//           ?.replace(/[^\d.]/g, "")
//           .replace(".", "");

//         const elements = document.querySelectorAll("[data-purchase-amount]");

//           if (price) {
//             elements.forEach((element) => {
//               element.setAttribute("data-purchase-amount", price);
//             });
//           }
//         const klarnaElements = document.querySelectorAll("#wrapper-lensadvisor-jtpl klarna-placement");

//         klarnaElements.forEach((klarnaElement) => {
//           const shadowRoot = klarnaElement.shadowRoot;

//           if (!shadowRoot) return;

//           // Style sirf ek baar add hogi har shadowRoot me
//           if (!shadowRoot.querySelector("#klarna-custom-style")) {
//             const style = document.createElement("style");
//             style.id = "klarna-custom-style";
//             style.textContent = `
//                   .container {
//                     flex-direction: row-reverse !important;
//                     background: transparent !important;
//                     border: 0 !important;
//                     padding: 0 !important;
//                     justify-content: flex-end !important;
//                     position: relative;
//                   }
//                   .container.order-summary-klarna{
//                     justify-content: center !important;
//                   }
//                   .container button.link {
//                     position: absolute;
//                     inset: 0;
//                     width: 100%;
//                     height: auto;
//                     font-size: 0;
//                   }
//                   .container .text-wrapper p.legal{
//                     display:none !important;
//                   }
//                   .container .text-wrapper {
//                     margin-left: 0;
//                     color: #8a857d;
//                     font-size: 12px;
//                     line-height: normal;
//                     margin-right: 3px;
//                   }
//                   .container .text-wrapper strong {
//                     font-weight: normal;
//                   }
//                   .container .badge svg {
//                     height: 18px;
//                     width: 40px;
//                     // transform: translateY(1px);
//                   }
//                   @media (max-width: 1140px) {
//                     .container .text-wrapper {
//                       font-size: 10px;
//                     }
//                   }
//                   @media (max-width: 994px) {
//                     .container .text-wrapper {
//                       font-size: 8.5px;
//                     }
//                   }
//                   @media (max-width: 767px) {
//                    .desktop-klarna .container {
//                       justify-content: center !important;
//                     }
//                     .container .text-wrapper {
//                       font-size: 11px;
//                     }
//                   }
//                 `;

//                 klarnaElement.shadowRoot.appendChild(style);
//             }
//           });
//       }, 10);

//         document.querySelector(".la-progress-bar-step").textContent = "Step 8 of 9";
//         Addon = true;

//       if(EnableDescription == true){
//         const description10 = ``;
//         document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
//               'afterend', `<p class="la-prescription-description text-center">${description10}</p>`
//         );
//       }
//       if(EnableTitle == true){
//         const title10 = ``;
//         if(title10 != ''){
//           document.getElementById("la_prescriptionSelect_title").textContent = title10;
//         }
//       }
// });
document.addEventListener('LensAdvizor:addOns:rendered', function(e) {
  setTimeout(function(){
    document.querySelector(".prescription-value-9").classList.remove("hide-prescription");
    document.querySelectorAll('.la-label-btn-wrapper').forEach(function (btn) {
        btn.addEventListener('click', function () {
            const contentWrapper = this.querySelector('.la-label-content-wrapper');
            if (contentWrapper?.querySelector('.delivery-badge')) {
                nextDay = true;
                document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
            }else{
                nextDay = false;
                const USEDFOR = document.querySelector(".la-footer-frame-prescription.value1").textContent;
                const USEDPRES = document.querySelector(".la-footer-frame-prescription.value3").textContent;
                const LENSPRES = document.querySelector(".la-footer-frame-prescription.value4").textContent;
                const LENSCOLOUR = document.querySelector(".la-footer-frame-prescription.value5").textContent;

                if(USEDFOR.includes("Varifocal")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                } else if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
                  document.querySelectorAll(".card-info-wrapper").forEach(function (element) {
                    element.innerHTML = `
                      <div class="dispatch-text">
                        
                      </div>`;
                    });
                    document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                } else if(LENSPRES.includes("Ray Ban")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;  
                } else if(LENSPRES.includes("Oakley")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                } else if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `5-7 Days`;
                } else if(USEDFOR.includes("Occupational")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                } else if(USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                } else if(USEDFOR.includes("Ready Reader")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `1-3 Days`;
                } else if(USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                } else{
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                }
                  
            }
        });
    });
    const USEDFOR = document.querySelector(".la-footer-frame-prescription.value1").textContent;
    const USEDPRES = document.querySelector(".la-footer-frame-prescription.value3").textContent;
    const LENSPRES = document.querySelector(".la-footer-frame-prescription.value4").textContent;
    const LENSCOLOUR = document.querySelector(".la-footer-frame-prescription.value5").textContent;

      if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror") || USEDFOR.includes("Varifocal") || USEDFOR.includes("Occupational") || USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised") || USEDFOR.includes("Ready Reader") || USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
          nextDay = false;
      }
      if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
        nextDay = false;
      }

    if(nextDay == false){
      document.querySelectorAll('.la-label-btn-wrapper').forEach(function (btn) {
          const delvbadge = btn.querySelector('.delivery-badge');
          if (delvbadge) {
              delvbadge.remove();
                if(USEDFOR.includes("Varifocal")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                } else if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
                  document.querySelectorAll(".card-info-wrapper").forEach(function (element) {
                    element.innerHTML = `
                      <div class="dispatch-text">
                        
                      </div>`;
                    });
                    document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                } else if(LENSPRES.includes("Ray Ban")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;  
                } else if(LENSPRES.includes("Oakley")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
                } else if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `5-7 Days`;
                } else if(USEDFOR.includes("Occupational")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
                } else if(USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                } else if(USEDFOR.includes("Ready Reader")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `1-3 Days`;
                } else if(USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
                } else{
                  document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
                }
          }
          if(USEDFOR.includes("Varifocal")){
            document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
          } else if(LENSPRES.includes("ZEISS PhotoFusion X - Light Sensitive") && LENSCOLOUR.includes("Green") && USEDPRES.includes("Light Sensitive")){
            document.querySelectorAll(".card-info-wrapper").forEach(function (element) {
              element.innerHTML = `
                <div class="dispatch-text">
                  
                </div>`;
              });
              document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
          } else if(LENSPRES.includes("Ray Ban")){
            document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
          } else if(LENSPRES.includes("Oakley")){
            document.querySelector(".la-footer-frame-prescription.value9").textContent = `6-10 Days`;
          } else if(USEDPRES.includes("Mirror") || USEDPRES.includes("mirror")){
            document.querySelector(".la-footer-frame-prescription.value9").textContent = `5-7 Days`;
          } else if(USEDFOR.includes("Occupational")){
            document.querySelector(".la-footer-frame-prescription.value9").textContent = `7-10 Days`;
          } else if(USEDPRES.includes("Gradient") || USEDPRES.includes("Polarised")){
            document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
          } else if(USEDFOR.includes("Ready Reader")){
            document.querySelector(".la-footer-frame-prescription.value9").textContent = `1-3 Days`;
          } else if(USEDFOR.includes("Fashion") || USEDFOR.includes("Blue Light")){
            document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
          } else{
            document.querySelector(".la-footer-frame-prescription.value9").textContent = `3-5 Days`;
          }
      });
    }else{
      document.querySelector(".la-footer-frame-prescription.value9").textContent = "Next Day Available";
    }

    let lensPriceDiv;
    if(window.outerWidth >= 768){
    lensPriceDiv = document.querySelector(
          '.fe-flow-jtpl .la-footer-row-wrapper:nth-of-type(4):not(.la-d-none) .la-footer-lens-price'
        );
      } else{
        lensPriceDiv = document.querySelector(
          '.fe-flow-jtpl .la-footer-row-wrapper:nth-of-type(5):not(.la-d-none) .la-footer-lens-price'
        );
      }
      if (lensPriceDiv && !lensPriceDiv.parentElement.querySelector('.currency-symbol')) {
        lensPriceDiv.insertAdjacentHTML(
          'beforebegin',
          `<div class="currency-symbol">${Symbolcurrency}</div>`
        );
      }

  }, 10);
const usedFOR = document.querySelector(".la-footer-frame-prescription.value1").textContent; 
const usedLens = document.querySelector(".la-footer-frame-prescription.value4").textContent;
if(usedFOR.includes("Distance") || usedFOR.includes("Reading") || usedLens.includes("Ray Ban")){
setTimeout(() => {
  const SkipButton = document.querySelector(".la-skip-add-on-wrapper");
  if(SkipButton){
    SkipButton.insertAdjacentHTML('beforebegin', `<div class="add-on-selector text-center" style="display:none !important;">None selected</div>`);
  }
  document.querySelectorAll(".la-label-btn-wrapper").forEach(function (item) {
    const input = item.querySelector("input");

    item.classList.toggle("la-prev-selected", input && input.checked);
    if(input && input.checked){
      document.querySelector(".prescription-value-8").classList.remove("hide-prescription"); 
      let totalPrice = 0;
                  let totalAdded = 0;       
                  document.querySelectorAll(".la-label-btn-wrapper").forEach(function (item) {
                      const input = item.querySelector('input[type="checkbox"], input[type="radio"]');
                      if (input && input.checked) {
                          totalAdded++;
                          let priceEl = 0;
                          if(EnableDiscount == true){
                            priceEl = item.querySelector(".new-price"); 
                           } else{
                            priceEl = item.querySelector(".la-label-price"); 
                           }
                          if (priceEl) {
                              const price = parseFloat(
                                  priceEl.textContent.replace(/[^0-9.-]+/g, "")
                              ) || 0;
                              totalPrice += price;
                          }
                      }
                  });
                  
                  let currency = "";
                  let firstPrice = 0;
                  if(EnableDiscount == true){
                  firstPrice = document.querySelector(".la-label-btn-wrapper .new-price");
                  } else{
                    firstPrice = document.querySelector(".la-label-btn-wrapper .la-label-price");
                  }
                  if (firstPrice) {
                      const match = firstPrice.textContent.trim().match(/^[^\d-]+/);
                      currency = match ? match[0] : "";
                  }
                  if(totalAdded == 0){
                    document.querySelector(".add-on-selector").textContent = `None selected`;
                    // document.querySelector(".prescription-value-8").classList.add("hide-prescription");
                    document.querySelector(".add-on-selector").classList.remove("add-on-added");
                  } else{
                     document.querySelector(".add-on-selector").classList.add("add-on-added");
                    document.querySelector(".add-on-selector").textContent = `${totalAdded} added · +${currency}${totalPrice.toFixed(2)}`;
                  }
    }
});
//**************   Addon Product Title description start   *************/ 
// const EnableAddOnTitle = true;
// if(EnableAddOnTitle == true){
//   const addonTitles = [
//     `Do you use computers and screens a lot? Add a blue-light coating.`,
//     `Accidental damage cover for scratches or breakage.`,
//     ``
//   ];

//   document.querySelectorAll(".la-label-btn-wrapper").forEach(function (item, index) {
//     const title = addonTitles[index];

//     if (title && !item.querySelector(".addon-title")) {
//       item.insertAdjacentHTML(
//         "afterbegin",
//         `<div class="addon-title">${title}</div>`
//       );     
//     }
//   });
//   const wrappers = document.querySelectorAll(".la-label-btn-wrapper .addon-title");
//   // console.log(wrappers);
//   const titleToShow =
//     wrappers.length === 1
//       ? addonTitles[1]
//       : null;
//       // console.log(titleToShow);
//   if(titleToShow !== null){
//   document.querySelector(".la-label-btn-wrapper .addon-title").textContent = titleToShow;

//   }
// }
//**************   Addon Product Title description end   *************/ 

}, 30);

  const html = document.getElementById('la_prescriptionSelect_title').innerHTML;
    const div = document.createElement('div');
    div.innerHTML = html;

    const text = [...div.childNodes]
        .filter(node => node.nodeType === Node.TEXT_NODE)
        .map(node => node.textContent.trim())
        .filter(Boolean)[0];

    // console.log(text);

    let cleanedText = text
    .toLowerCase()
    .replace(/\b(choose|your|lens|lenses|chose|additional)\b/g, "")
    .replace(/\s+/g, " ")
    .trim();

    // console.log(cleanedText);
    if(cleanedText == "tint"){
      cleanedText = "Colour"
    } else if(cleanedText.includes('color') || cleanedText.includes('colour')){
      cleanedText = "Colour"
    } else if(cleanedText.includes('thickness')){
      cleanedText = "Thickness"
    } else if(cleanedText.includes('coating')){
      cleanedText = "Coating"
    } else if(cleanedText.includes('occupational')){
      cleanedText = "Occupational"
    }

  document.querySelector(".prescription-heading-8").textContent = cleanedText;

    document.querySelectorAll(".la-label-btn-wrapper").forEach(function (el) {
      el.addEventListener("click", function (e) {

        const titles = [];
        let Checked = false;

        document.querySelectorAll(".la-label-btn-wrapper").forEach(function (item) {
            const input = item.querySelector("input");

            if (input && input.checked) {
              Checked = true;
                const title = item.querySelector(".la-label-content-box .la-label-title")?.textContent.trim();
                if (title) {
                    titles.push(title);
                }
            }
            
        });

        // document.querySelector(".la-footer-frame-prescription.value8").innerHTML = titles.join("<br>");

        // if(Checked == false){
        //   const text = this.querySelector(".la-label-content-box .la-label-title")?.textContent.trim();
        //   document.querySelector(".la-footer-frame-prescription.value8").textContent = text;
        // }

        //       const inputVal = this.querySelector("input").value;
        //       document.querySelector(".la-footer-frame-prescription.value8").setAttribute("addOn", inputVal);

        //       if(EnableDiscount == false && Checked == false){
        //         let OrignalpriceBox;
        //              OrignalpriceBox = this.querySelector(".la-label-price").textContent;
        //             //  console.log(OrignalpriceBox);
        //             if (OrignalpriceBox !== null && OrignalpriceBox !== undefined && OrignalpriceBox !== ""){
        //               document.querySelector(".la-footer-frame-prescription.value8").setAttribute("new-price", OrignalpriceBox);
        //             }
        //       // } else{
        //       //   const priceRow = this.querySelector(".la-label-price .price-box");
        //       //   if (priceRow) {
        //       //     document.querySelector(".la-footer-frame-prescription.value8").setAttribute("new-price", priceRow.outerHTML);
        //       //   }
        //       }
              
              document.querySelector(".prescription-value-8").classList.remove("hide-prescription");   

              setTimeout(() => {  

                //************************   Add-on selection text when add-on select   *******************************/

                  let totalPrice = 0;
                  let totalAdded = 0;       
                  document.querySelectorAll(".la-label-btn-wrapper").forEach(function (item) {
                      const input = item.querySelector('input[type="checkbox"], input[type="radio"]');
                      if (input && input.checked) {
                          totalAdded++;
                          let priceEl = 0;
                          if(EnableDiscount == true){
                            priceEl = item.querySelector(".new-price"); 
                           } else{
                            priceEl = item.querySelector(".la-label-price"); 
                           }
                          if (priceEl) {
                              const price = parseFloat(
                                  priceEl.textContent.replace(/[^0-9.-]+/g, "")
                              ) || 0;
                              totalPrice += price;
                          }
                      }
                  });
                  
                  let currency = "";
                  let firstPrice = 0;
                  if(EnableDiscount == true){
                  firstPrice = document.querySelector(".la-label-btn-wrapper .new-price");
                  } else{
                    firstPrice = document.querySelector(".la-label-btn-wrapper .la-label-price");
                  }
                  if (firstPrice) {
                      const match = firstPrice.textContent.trim().match(/^[^\d-]+/);
                      currency = match ? match[0] : "";
                  }
                  if(totalAdded == 0){
                    document.querySelector(".add-on-selector").textContent = `None selected`;
                    // document.querySelector(".prescription-value-8").classList.add("hide-prescription");
                    document.querySelector(".add-on-selector").classList.remove("add-on-added");
                  } else{
                     document.querySelector(".add-on-selector").classList.add("add-on-added");
                    document.querySelector(".add-on-selector").textContent = `${totalAdded} added · +${currency}${totalPrice.toFixed(2)}`;
                  }

                  //************************   Add-on selection text when add-on end   *******************************/

                  var discount = false;
                  if(discount == true){

                  //************************    LensPrices with discount when add-on select   *******************************/ 

                    document.querySelectorAll('.la-footer-row').forEach(function (row) {

                      const symbolEl = row.querySelector('.currency-symbol');
                      const priceEl = row.querySelector('.la-footer-lens-price');

                      if (!symbolEl || !priceEl) return; // Element nahi mila to skip

                      const symbol = symbolEl.textContent.trim();
                      const price = parseFloat(priceEl.textContent.trim());

                      if (isNaN(price)) return;

                      const discount = `25`;
                      const discountedPrice = (price * (100 - discount) / 100).toFixed(2);

                      var disamount = price.toFixed(2) - discountedPrice;
                      document.querySelector(".discount-ammount").textContent = `- ${symbol}${disamount.toFixed(2)}`;
                      document.querySelector(".discount-ammount").setAttribute("data-price", disamount.toFixed(2));

                      const parentLabel = document.querySelector(".la-choose-prescription-wrapper");
                      if (parentLabel && parentLabel.classList.contains("la-render-review")) {
                          document.querySelector(".lens-discount-price").textContent = `- ${symbol}${disamount.toFixed(2)}`;
                      }

                      priceEl.innerHTML = `
                        <div class="lenses-discount-price">
                          <span class="old-price">
                              ${symbol}${price.toFixed(2)}
                          </span>
                          <span class="final-price">
                              ${symbol}${discountedPrice}
                          </span>
                        </div>
                      `;
                    }); 

                    //************************    LensPrices with discount when add-on end   *******************************/  
                    
                    //************************    Add-On Prices with discount when add-on select    *******************************/ 

                    const addonPriceEl = document.querySelectorAll(".la-footer-addon-price");
                    addonPriceEl.forEach(function (addonPriceEl) {

                        // Already discounted? Skip this element
                        if (addonPriceEl.querySelector(".lenses-discount-price")) {
                            return;
                        }

                        const discountAmountEl = document.querySelector(".discount-ammount");

                        if (addonPriceEl) {
                            const Priceaddon = addonPriceEl.textContent;
                            const currencySymbol = document.body.getAttribute("theme-currency");

                            let addonPrice = parseFloat(
                                addonPriceEl.textContent.replace(/[^\d.]/g, "")
                            );

                            const discountt = Number(`25`);

                            let finalPrice = addonPrice - (addonPrice * (discountt / 100));

                            if (finalPrice > 0) {

                                const addonDiscount = addonPrice - finalPrice;

                                if (discountAmountEl) {
                                    let existingDiscount = parseFloat(
                                        discountAmountEl.textContent.replace(/[^\d.]/g, "")
                                    );

                                    let totalDiscount = existingDiscount + addonDiscount;

                                    discountAmountEl.textContent = `- ${currencySymbol}${totalDiscount.toFixed(2)}`;
                                    discountAmountEl.setAttribute("data-price", totalDiscount.toFixed(2));

                                    const parentLabel = document.querySelector(".la-choose-prescription-wrapper");
                                    if (parentLabel && parentLabel.classList.contains("la-render-review")) {
                                        document.querySelector(".lens-discount-price").textContent =
                                            `- ${currencySymbol}${totalDiscount.toFixed(2)}`;
                                    }
                                }

                                addonPriceEl.innerHTML = `
                                    <div class="lenses-discount-price">
                                        <span class="old-price">${Priceaddon}</span>
                                        <span class="final-price">
                                            ${currencySymbol}${finalPrice.toFixed(2)}
                                        </span>
                                    </div>
                                `;
                            }
                        }
                    });
                    //************************    Add-On Prices with discount when add-on select end   *******************************/ 
                  }

                  //**********************  Add-on sum  ***************************/
                      var discount = false;
                      let total = 0;
                      if(discount == true){
                        const oldPrices = document.querySelectorAll(".la-footer-addon-price span.old-price");
                            oldPrices.forEach(el => {
                                const text = el.textContent.trim();

                                const price = parseFloat(text.replace(/[^0-9.]/g, ""));

                                if (!isNaN(price)) {
                                    total += price;
                                }
                            });
                      } else{
                        const oldPrices = document.querySelectorAll(".la-footer-addon-price");
                            oldPrices.forEach(el => {
                                const text = el.textContent.trim();

                                const price = parseFloat(text.replace(/[^0-9.]/g, ""));

                                if (!isNaN(price)) {
                                    total += price;
                                }
                            });
                      }
                        
                        const totalDiv = document.createElement("div");
                        totalDiv.className = "la-addon-price";
                        // totalDiv.textContent = `${Symbolcurrency}${total.toFixed(2)}`;

                        
                        const container = document.querySelector(".la-footer-addon-wrapper");
                        if (container) {
                          // if exist then remove
                          container.querySelector(".la-addon-price")?.remove();

                          const totalDiv = document.createElement("div");
                          totalDiv.className = "la-addon-price";

                          
                          if(discount == true){
                            const discounttt = `25`;
                            const discountedPricee = (total.toFixed(2) * (100 - discounttt) / 100).toFixed(2);
                            
                            totalDiv.innerHTML = `
                                    <div class="la-addon-discount-price">
                                        <span class="old-price">${Symbolcurrency}${total.toFixed(2)}</span>
                                        <span class="final-price">
                                            ${Symbolcurrency}${discountedPricee}
                                        </span>
                                    </div>
                                `;

                          }else{
                            totalDiv.textContent = `${Symbolcurrency}${total.toFixed(2)}`;
                          }

                          container.insertAdjacentElement("afterbegin", totalDiv);
                      }
                  //************************ Add-on Sum  ***************************/  
                
              const addOnprices = document.querySelector(".la-addon-price").innerHTML;
              document.querySelector(".la-footer-frame-prescription.value8").setAttribute("new-price", addOnprices);

              }, 0);
          });


          document.querySelectorAll(".la-label-btn-wrapper").forEach(function (el) {
            el.addEventListener("click", function (e) {
              setTimeout(function(){
                const footer = document.querySelector(".la-footer-addon-wrapper");
                const target = document.querySelector(".la-footer-frame-prescription.value8");

                // if (!footer || !target) return;

                // Get all addon text values
                const texts = Array.from(
                    footer.querySelectorAll(".la-footer-text")
                )
                .map(function (item) {
                    return item.textContent.trim();
                })
                .filter(Boolean);

                // Get addon price
                const priceElement = footer.querySelector(".la-addon-price");
                const price = priceElement ? priceElement.textContent.trim() : "";

                // Set text with <br> between multiple values
                target.innerHTML = texts.join("<br>");

                // Set new-price attribute
                target.setAttribute("new-price", price);
                }, 200);
            });
        });

    });

    var SumAddOntitle = document.querySelector(".la-footer-frame-prescription.value8").textContent;
    document.querySelectorAll(".la-label-content-box .la-label-title").forEach(function (el) {
      var AddOntitle = el.textContent.trim();
      if(SumAddOntitle === AddOntitle){
        const parent = el.closest('.la-label-btn-wrapper');
        if (parent) {
            setTimeout(function(){
             parent.classList.add('la-prev-selected');
            }, 50);
        }
      }
    });


      setInterval(() => {
        const priceText = document
          .querySelector(".la-footer-row.la-subtotal .la-subtotal-price")
          ?.textContent.trim();

        const price = priceText
          ?.replace(/[^\d.]/g, "")
          .replace(".", "");

        const elements = document.querySelectorAll("[data-purchase-amount]");

          if (price) {
            elements.forEach((element) => {
              element.setAttribute("data-purchase-amount", price);
            });
          }
        const klarnaElements = document.querySelectorAll("#wrapper-lensadvisor-jtpl klarna-placement");

        klarnaElements.forEach((klarnaElement) => {
          const shadowRoot = klarnaElement.shadowRoot;

          if (!shadowRoot) return;

          // Style sirf ek baar add hogi har shadowRoot me
          if (!shadowRoot.querySelector("#klarna-custom-style")) {
            const style = document.createElement("style");
            style.id = "klarna-custom-style";
            style.textContent = `
                  .container {
                    flex-direction: row-reverse !important;
                    background: transparent !important;
                    border: 0 !important;
                    padding: 0 !important;
                    justify-content: flex-end !important;
                    position: relative;
                  }
                  .container.order-summary-klarna{
                    justify-content: center !important;
                  }
                  .container button.link {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: auto;
                    font-size: 0;
                  }
                  .container .text-wrapper p.legal{
                    display:none !important;
                  }
                  .container .text-wrapper {
                    margin-left: 0;
                    color: #8a857d;
                    font-size: 12px;
                    line-height: normal;
                    margin-right: 3px;
                  }
                  .container .text-wrapper strong {
                    font-weight: normal;
                  }
                  .container .badge svg {
                    height: 18px;
                    width: 40px;
                    // transform: translateY(1px);
                  }
                  @media (max-width: 1140px) {
                    .container .text-wrapper {
                      font-size: 10px;
                    }
                  }
                  @media (max-width: 994px) {
                    .container .text-wrapper {
                      font-size: 8.5px;
                    }
                  }
                  @media (max-width: 767px) {
                   .desktop-klarna .container {
                      justify-content: center !important;
                    }
                    .container .text-wrapper {
                      font-size: 11px;
                    }
                  }
                `;

                klarnaElement.shadowRoot.appendChild(style);
            }
          });
      }, 10);

        document.querySelector(".la-progress-bar-step").textContent = "Step 8 of 9";
        Addon = true;

      if(EnableDescription == true){
        const description10 = ``;
        document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
              'afterend', `<p class="la-prescription-description text-center">${description10}</p>`
        );
      }
      if(EnableTitle == true){
        const title10 = ``;
        if(title10 != ''){
          document.getElementById("la_prescriptionSelect_title").textContent = title10;
        }
      }
}else{
setTimeout(() => {
  const SkipButton = document.querySelector(".la-skip-add-on-wrapper");
  if(SkipButton){
    SkipButton.insertAdjacentHTML('beforebegin', `<div class="add-on-selector text-center">None selected</div>`);
  }
  document.querySelectorAll(".la-label-btn-wrapper").forEach(function (item) {
    const input = item.querySelector("input");

    item.classList.toggle("la-prev-selected", input && input.checked);
    if(input && input.checked){
      document.querySelector(".prescription-value-8").classList.remove("hide-prescription"); 
      let totalPrice = 0;
                  let totalAdded = 0;       
                  document.querySelectorAll(".la-label-btn-wrapper").forEach(function (item) {
                      const input = item.querySelector('input[type="checkbox"], input[type="radio"]');
                      if (input && input.checked) {
                          totalAdded++;
                          let priceEl = 0;
                          if(EnableDiscount == true){
                            priceEl = item.querySelector(".new-price"); 
                           } else{
                            priceEl = item.querySelector(".la-label-price"); 
                           }
                          if (priceEl) {
                              const price = parseFloat(
                                  priceEl.textContent.replace(/[^0-9.-]+/g, "")
                              ) || 0;
                              totalPrice += price;
                          }
                      }
                  });
                  
                  let currency = "";
                  let firstPrice = 0;
                  if(EnableDiscount == true){
                  firstPrice = document.querySelector(".la-label-btn-wrapper .new-price");
                  } else{
                    firstPrice = document.querySelector(".la-label-btn-wrapper .la-label-price");
                  }
                  if (firstPrice) {
                      const match = firstPrice.textContent.trim().match(/^[^\d-]+/);
                      currency = match ? match[0] : "";
                  }
                  const addOnSelector = document.querySelector(".add-on-selector");
                    const prescriptionValue = document.querySelector(".prescription-value-8");

                    if (addOnSelector) {
                        if (totalAdded === 0) {
                            addOnSelector.textContent = "None selected";
                            addOnSelector.classList.remove("add-on-added");
                        } else {
                            addOnSelector.textContent = `${totalAdded} added · +${currency}${totalPrice.toFixed(2)}`;
                            addOnSelector.classList.add("add-on-added");
                        }
                    }

                    if (prescriptionValue && totalAdded === 0) {
                        prescriptionValue.classList.add("hide-prescription");
                    }
    }
});

const addonTitles = [
  `Do you use computers and screens a lot? Add a blue-light coating.`,
  `Accidental damage cover for scratches or breakage.`,
  ``
];

document.querySelectorAll(".la-label-btn-wrapper").forEach(function (item, index) {
  const title = addonTitles[index];

  if (title && !item.querySelector(".addon-title")) {
    item.insertAdjacentHTML(
      "afterbegin",
      `<div class="addon-title">${title}</div>`
    );     
  }
});
const wrappers = document.querySelectorAll(".la-label-btn-wrapper .addon-title");
console.log(wrappers);
const titleToShow =
  wrappers.length === 1
    ? addonTitles[1]
    : null;
    console.log(titleToShow);
if(titleToShow !== null){
document.querySelector(".la-label-btn-wrapper .addon-title").textContent = titleToShow;

}

}, 30);

  const html = document.getElementById('la_prescriptionSelect_title').innerHTML;
    const div = document.createElement('div');
    div.innerHTML = html;

    const text = [...div.childNodes]
        .filter(node => node.nodeType === Node.TEXT_NODE)
        .map(node => node.textContent.trim())
        .filter(Boolean)[0];

    // console.log(text);

    let cleanedText = text
    .toLowerCase()
    .replace(/\b(choose|your|lens|lenses|chose|additional)\b/g, "")
    .replace(/\s+/g, " ")
    .trim();

    // console.log(cleanedText);
    if(cleanedText == "tint"){
      cleanedText = "Colour"
    } else if(cleanedText.includes('color') || cleanedText.includes('colour')){
      cleanedText = "Colour"
    }

  document.querySelector(".prescription-heading-8").textContent = cleanedText;

    document.querySelectorAll(".la-label-btn-wrapper").forEach(function (el) {
      el.addEventListener("click", function () {

        const titles = [];
        document.querySelectorAll(".la-label-btn-wrapper").forEach(function (item) {
            const input = item.querySelector("input");

            if (input && input.checked) {
                const title = item.querySelector(".la-label-content-box .la-label-title")?.textContent.trim();
                if (title) {
                    titles.push(title);
                }
            }
            
        });

        document.querySelector(".la-footer-frame-prescription.value8").innerHTML = titles.join("<br>");
          // const text = this.querySelector(".la-label-content-box .la-label-title")?.textContent.trim();
          //     document.querySelector(".la-footer-frame-prescription.value8").textContent = text;

              const inputVal = this.querySelector("input").value;
              document.querySelector(".la-footer-frame-prescription.value8").setAttribute("addOn", inputVal);

              // if(EnableDiscount == false){
              //   let OrignalpriceBox;
              //        OrignalpriceBox = this.querySelector(".la-label-price").textContent;
              //        console.log(OrignalpriceBox);
              //       if (OrignalpriceBox !== null && OrignalpriceBox !== undefined && OrignalpriceBox !== ""){
              //         document.querySelector(".la-footer-frame-prescription.value8").setAttribute("new-price", OrignalpriceBox);
              //       }
              // } else{
              //   const priceRow = this.querySelector(".la-label-price .price-box");
              //   if (priceRow) {
              //     document.querySelector(".la-footer-frame-prescription.value8").setAttribute("new-price", priceRow.outerHTML);
              //   }
              // }
              
              document.querySelector(".prescription-value-8").classList.remove("hide-prescription");   

              setTimeout(() => {  

                //************************   Add-on selection text when add-on select   *******************************/

                  let totalPrice = 0;
                  let totalAdded = 0;       
                  document.querySelectorAll(".la-label-btn-wrapper").forEach(function (item) {
                      const input = item.querySelector('input[type="checkbox"], input[type="radio"]');
                      if (input && input.checked) {
                          totalAdded++;
                          let priceEl = 0;
                          if(EnableDiscount == true){
                            priceEl = item.querySelector(".new-price"); 
                           } else{
                            priceEl = item.querySelector(".la-label-price"); 
                           }
                          if (priceEl) {
                              const price = parseFloat(
                                  priceEl.textContent.replace(/[^0-9.-]+/g, "")
                              ) || 0;
                              totalPrice += price;
                          }
                      }
                  });
                  
                  let currency = "";
                  let firstPrice = 0;
                  if(EnableDiscount == true){
                  firstPrice = document.querySelector(".la-label-btn-wrapper .new-price");
                  } else{
                    firstPrice = document.querySelector(".la-label-btn-wrapper .la-label-price");
                  }
                  if (firstPrice) {
                      const match = firstPrice.textContent.trim().match(/^[^\d-]+/);
                      currency = match ? match[0] : "";
                  }
                  if(totalAdded == 0){
                    document.querySelector(".add-on-selector").textContent = `None selected`;
                    document.querySelector(".prescription-value-8").classList.add("hide-prescription");
                    document.querySelector(".add-on-selector").classList.remove("add-on-added");
                  } else{
                     document.querySelector(".add-on-selector").classList.add("add-on-added");
                    document.querySelector(".add-on-selector").textContent = `${totalAdded} added · +${currency}${totalPrice.toFixed(2)}`;
                  }

                  //************************   Add-on selection text when add-on end   *******************************/

                  var discount = false;
                  if(discount == true){

                  //************************    LensPrices with discount when add-on select   *******************************/ 

                    document.querySelectorAll('.la-footer-row').forEach(function (row) {

                      const symbolEl = row.querySelector('.currency-symbol');
                      const priceEl = row.querySelector('.la-footer-lens-price');

                      if (!symbolEl || !priceEl) return; // Element nahi mila to skip

                      const symbol = symbolEl.textContent.trim();
                      const price = parseFloat(priceEl.textContent.trim());

                      if (isNaN(price)) return;

                      const discount = `25`;
                      const discountedPrice = (price * (100 - discount) / 100).toFixed(2);

                      var disamount = price.toFixed(2) - discountedPrice;
                      document.querySelector(".discount-ammount").textContent = `- ${symbol}${disamount.toFixed(2)}`;
                      document.querySelector(".discount-ammount").setAttribute("data-price", disamount.toFixed(2));

                      const parentLabel = document.querySelector(".la-choose-prescription-wrapper");
                      if (parentLabel && parentLabel.classList.contains("la-render-review")) {
                          document.querySelector(".lens-discount-price").textContent = `- ${symbol}${disamount.toFixed(2)}`;
                      }

                      priceEl.innerHTML = `
                        <div class="lenses-discount-price">
                          <span class="old-price">
                              ${symbol}${price.toFixed(2)}
                          </span>
                          <span class="final-price">
                              ${symbol}${discountedPrice}
                          </span>
                        </div>
                      `;
                    }); 

                    //************************    LensPrices with discount when add-on end   *******************************/  
                    
                    //************************    Add-On Prices with discount when add-on select    *******************************/ 

                    const addonPriceEl = document.querySelectorAll(".la-footer-addon-price");
                    addonPriceEl.forEach(function (addonPriceEl) {

                        // Already discounted? Skip this element
                        if (addonPriceEl.querySelector(".lenses-discount-price")) {
                            return;
                        }

                        const discountAmountEl = document.querySelector(".discount-ammount");

                        if (addonPriceEl) {
                            const Priceaddon = addonPriceEl.textContent;
                            const currencySymbol = document.body.getAttribute("theme-currency");

                            let addonPrice = parseFloat(
                                addonPriceEl.textContent.replace(/[^\d.]/g, "")
                            );

                            const discountt = Number(`25`);

                            let finalPrice = addonPrice - (addonPrice * (discountt / 100));

                            if (finalPrice > 0) {

                                const addonDiscount = addonPrice - finalPrice;

                                if (discountAmountEl) {
                                    let existingDiscount = parseFloat(
                                        discountAmountEl.textContent.replace(/[^\d.]/g, "")
                                    );

                                    let totalDiscount = existingDiscount + addonDiscount;

                                    discountAmountEl.textContent = `- ${currencySymbol}${totalDiscount.toFixed(2)}`;
                                    discountAmountEl.setAttribute("data-price", totalDiscount.toFixed(2));

                                    const parentLabel = document.querySelector(".la-choose-prescription-wrapper");
                                    if (parentLabel && parentLabel.classList.contains("la-render-review")) {
                                        document.querySelector(".lens-discount-price").textContent =
                                            `- ${currencySymbol}${totalDiscount.toFixed(2)}`;
                                    }
                                }

                                addonPriceEl.innerHTML = `
                                    <div class="lenses-discount-price">
                                        <span class="old-price">${Priceaddon}</span>
                                        <span class="final-price">
                                            ${currencySymbol}${finalPrice.toFixed(2)}
                                        </span>
                                    </div>
                                `;
                            }
                        }
                    });
                    //************************    Add-On Prices with discount when add-on select end   *******************************/ 
                  }

                  //**********************  Add-on sum  ***************************/
                      var discount = false;
                      let total = 0;
                      if(discount == true){
                        const oldPrices = document.querySelectorAll(".la-footer-addon-price span.old-price");
                            oldPrices.forEach(el => {
                                const text = el.textContent.trim();

                                const price = parseFloat(text.replace(/[^0-9.]/g, ""));

                                if (!isNaN(price)) {
                                    total += price;
                                }
                            });
                      } else{
                        const oldPrices = document.querySelectorAll(".la-footer-addon-price");
                            oldPrices.forEach(el => {
                                const text = el.textContent.trim();

                                const price = parseFloat(text.replace(/[^0-9.]/g, ""));

                                if (!isNaN(price)) {
                                    total += price;
                                }
                            });
                      }
                        
                        const totalDiv = document.createElement("div");
                        totalDiv.className = "la-addon-price";
                        // totalDiv.textContent = `${Symbolcurrency}${total.toFixed(2)}`;

                        
                        const container = document.querySelector(".la-footer-addon-wrapper");
                        if (container) {
                          // if exist then remove
                          container.querySelector(".la-addon-price")?.remove();

                          const totalDiv = document.createElement("div");
                          totalDiv.className = "la-addon-price";

                          
                          if(discount == true){
                            const discounttt = `25`;
                            const discountedPricee = (total.toFixed(2) * (100 - discounttt) / 100).toFixed(2);
                            
                            totalDiv.innerHTML = `
                                    <div class="la-addon-discount-price">
                                        <span class="old-price">${Symbolcurrency}${total.toFixed(2)}</span>
                                        <span class="final-price">
                                            ${Symbolcurrency}${discountedPricee}
                                        </span>
                                    </div>
                                `;

                          }else{
                            totalDiv.textContent = `${Symbolcurrency}${total.toFixed(2)}`;
                          }

                          container.insertAdjacentElement("afterbegin", totalDiv);
                      }
                  //************************ Add-on Sum  ***************************/  
                
              const addOnprices = document.querySelector(".la-addon-price").innerHTML;
              document.querySelector(".la-footer-frame-prescription.value8").setAttribute("new-price", addOnprices);

              }, 0);
          });
    });

    var SumAddOntitle = document.querySelector(".la-footer-frame-prescription.value8").textContent;
    document.querySelectorAll(".la-label-content-box .la-label-title").forEach(function (el) {
      var AddOntitle = el.textContent.trim();
      if(SumAddOntitle === AddOntitle){
        const parent = el.closest('.la-label-btn-wrapper');
        if (parent) {
            setTimeout(function(){
             parent.classList.add('la-prev-selected');
            }, 50);
        }
      }
    });


      setInterval(() => {
        const priceText = document
          .querySelector(".la-footer-row.la-subtotal .la-subtotal-price")
          ?.textContent.trim();

        const price = priceText
          ?.replace(/[^\d.]/g, "")
          .replace(".", "");

        const elements = document.querySelectorAll("[data-purchase-amount]");

          if (price) {
            elements.forEach((element) => {
              element.setAttribute("data-purchase-amount", price);
            });
          }
        const klarnaElements = document.querySelectorAll("#wrapper-lensadvisor-jtpl klarna-placement");

        klarnaElements.forEach((klarnaElement) => {
          const shadowRoot = klarnaElement.shadowRoot;

          if (!shadowRoot) return;

          // Style sirf ek baar add hogi har shadowRoot me
          if (!shadowRoot.querySelector("#klarna-custom-style")) {
            const style = document.createElement("style");
            style.id = "klarna-custom-style";
            style.textContent = `
                  .container {
                    flex-direction: row-reverse !important;
                    background: transparent !important;
                    border: 0 !important;
                    padding: 0 !important;
                    justify-content: flex-end !important;
                    position: relative;
                  }
                  .container.order-summary-klarna{
                    justify-content: center !important;
                  }
                  .container button.link {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: auto;
                    font-size: 0;
                  }
                  .container .text-wrapper p.legal{
                    display:none !important;
                  }
                  .container .text-wrapper {
                    margin-left: 0;
                    color: #8a857d;
                    font-size: 12px;
                    line-height: normal;
                    margin-right: 3px;
                  }
                  .container .text-wrapper strong {
                    font-weight: normal;
                  }
                  .container .badge svg {
                    height: 18px;
                    width: 40px;
                    // transform: translateY(1px);
                  }
                  @media (max-width: 1140px) {
                    .container .text-wrapper {
                      font-size: 10px;
                    }
                  }
                  @media (max-width: 994px) {
                    .container .text-wrapper {
                      font-size: 8.5px;
                    }
                  }
                  @media (max-width: 767px) {
                   .desktop-klarna .container {
                      justify-content: center !important;
                    }
                    .container .text-wrapper {
                      font-size: 11px;
                    }
                  }
                `;

                klarnaElement.shadowRoot.appendChild(style);
            }
          });
      }, 10);

        document.querySelector(".la-progress-bar-step").textContent = "Step 8 of 9";
        Addon = true;

      if(EnableDescription == true){
        const description10 = ``;
        document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
              'afterend', `<p class="la-prescription-description text-center">${description10}</p>`
        );
      }
      if(EnableTitle == true){
        const title10 = ``;
        if(title10 != ''){
          document.getElementById("la_prescriptionSelect_title").textContent = title10;
        }
      }
}
});

document.addEventListener('LensAdvizor:review:rendered', function(e) {
document.querySelector(".prescription-value-9").classList.remove("hide-prescription");
  if(Addon == true){
    document.querySelector(".la-progress-bar-step").textContent = "Step 9 of 9";
  }else if(submissionMethods == false){
    document.querySelector(".la-progress-bar-step").textContent = "Step 7 of 7";
  } else{
    document.querySelector(".la-progress-bar-step").textContent = "Step 8 of 8";
  }
  
  document.getElementById("wrapper-lensadvisor-jtpl").classList.add("review-page");

    const removeSpaceAfterCurrency = (selector) => {
    document.querySelectorAll(selector).forEach(el => {
        el.childNodes.forEach(node => {
          if (node.nodeType === Node.TEXT_NODE) {
            node.textContent = node.textContent.replace(/([£$€¥])\s+/g, '$1');
          }
        });
      });
    };
    removeSpaceAfterCurrency('.la-label-title');
    removeSpaceAfterCurrency('.la-compare-at-price del');

    setTimeout(function(){
      var discount = false;
        if(discount == true){
           const currencySymbol = document.body.getAttribute('theme-currency');
          document.querySelectorAll(".la-review-right.la-label-title").forEach((el) => {
              let price = parseFloat(
                  el.textContent.replace(/[^\d.]/g, "")
              );

              if (!isNaN(price)) {

                const discount = `25`;
                let finalPrice = price - (price * discount / 100);
                  el.innerHTML = `
                  <div class="lenses-discount-price">
                      <span class="final-price">
                          ${currencySymbol}${finalPrice.toFixed(2)}
                      </span>
                      <span class="old-price">
                          ${currencySymbol}${price.toFixed(2)}
                      </span>
                  </div>`;
              }
          });
        }

        var consentenable = false;
          var consentenable = false;
        var consentHTML = `<div class="prescription-dispatch-message">Next-day delivery available on most lenses (order by 3pm). Varifocals and stronger prescriptions are made to order 7-10 working days.</div>
            <div class="prescription-order-consent-wrapper">
              <div class="prescription-order-note-wrapper">
                <label for="notes">Anything else on your prescription? (optional)</label>
                  <textarea id="notes" class="order-note-box" placeholder="e.g. prism values, or a note for our optical team"></textarea>
              </div>`;
        
          if(consentenable == true){
          consentHTML += `
              <div class="checkbox-container">
                <input type="checkbox" id="confirm" class="consent-text-input">
                <label for="confirm" class="consent-text-wrapper">
                  <p>I confirm these glasses are for someone over 16, not registered blind, with a prescription under 2 years old, and I agree to the <a href="/policies/terms-of-service" target="_blank" title="Terms of Service"><strong>Terms & Conditions</strong></a>.</p>
                </label>
              </div>
            `;
          }
          consentHTML +=`</div>`;
             const orderReview = document.querySelector(".la-review-main-wrapper");
         orderReview.insertAdjacentHTML('beforeend',consentHTML); 


          
          // const orderReview = document.querySelector(".la-review-main-wrapper");
          // orderReview.insertAdjacentHTML('beforeend', `<div class="prescription-dispatch-message">Next-day delivery available on most lenses (order by 3pm). Varifocals and stronger prescriptions are made to order 7-10 working days.</div>
          //   <div class="prescription-order-consent-wrapper">
          //     <div class="prescription-order-note-wrapper">
          //       <label for="notes">Anything else on your prescription? (optional)</label>
          //         <textarea id="notes" class="order-note-box" placeholder="e.g. prism values, or a note for our optical team"></textarea>
          //     </div>
          //     <div class="checkbox-container">
          //       <input type="checkbox" id="confirm" class="consent-text-input">
          //       <label for="confirm" class="consent-text-wrapper">
          //         <p>I confirm these glasses are for someone over 16, not registered blind, with a prescription under 2 years old, and I agree to the <a href="/policies/terms-of-service" target="_blank" title="Terms of Service"><strong>Terms & Conditions</strong></a>.</p>
          //       </label>
          //     </div>
          //   </div>
          //   `);

          document.addEventListener("input", function (e) {
              if (e.target.id === "notes") {
                  const value = e.target.value;

                  document.getElementById("hiddenordernoteProperty").value = value;

                  if (window.LensAdvizor) {
                      if (!window.LensAdvizor.customFieldData) {
                          window.LensAdvizor.customFieldData = {};
                      }
                      window.LensAdvizor.customFieldData["Order Note"] = value;
                      // const steps = LensAdvizor.navigationSteps.length;
                      // const index = LensAdvizor.stepIndex;
                      // LensAdvizor.renderReview();
                      // LensAdvizor.navigationSteps.length = steps;
                      // LensAdvizor.stepIndex = index;
                  }
              }
          });
          const valueDelivery = document.querySelector(".summary-prescription-title.value-option.value9").textContent;
          document.getElementById("nextdayProperty").value = valueDelivery;
          if (window.LensAdvizor) {
              if (!window.LensAdvizor.customFieldData) {
                  window.LensAdvizor.customFieldData = {};
              }
              window.LensAdvizor.customFieldData["Delivery"] = valueDelivery;
          }

            document.querySelectorAll('.la-label-description').forEach(function(el) {
                let lines = el.innerHTML.split('<br>');
                lines = lines.filter(function(line) {
                    return !line.trim().startsWith('Order Note:');
                });
                el.innerHTML = lines.join('<br>');
            });
            if(consentenable == true){
            document.querySelector(".la-prescription-form-btn.la-translate").setAttribute("disabled", "disabled");
              const checkbox = document.getElementById("confirm");
              const button = document.querySelector(".la-prescription-form-btn.la-translate");

              checkbox.addEventListener("change", function () {
                if (this.checked) {
                    button.removeAttribute("disabled");
                } else {
                    button.setAttribute("disabled", "disabled");
                }
            });
          }
    }, 10);
    var enableconsent = false;
      if(enableconsent == true){
        document.querySelector(".la-prescription-form-btn.la-translate").setAttribute("disabled", "disabled");
      }

      if(EnableDescription == true){
        const description11 = `Quick check of your build, then add it to your bag.`;
        document.getElementById("la_prescriptionSelect_title").insertAdjacentHTML(
              'afterend', `<p class="la-prescription-description text-center">${description11}</p>`
        );
      }
      if(EnableTitle == true){
        const title11 = ``;
        if(title11 != ''){
          document.getElementById("la_prescriptionSelect_title").textContent = title11;
        }
      }

});


var openPopup = false;
document.addEventListener('LensAdvizor:selectLensModal:open', function() {
    setTimeout(function(){
    const div1 = document.getElementById("la-boxy-footer-modal");
        const div2 = document.getElementById("la-tooltip-modal");
        const div3 = document.getElementById("lensadvizor-prescription-modal");

        const wrapper = document.createElement("div");
        wrapper.id = "wrapper-lensadvisor-jtpl";

        const outerWrapper = document.createElement("div");
        outerWrapper.id = "outer-wrapper";

        div1.parentNode.insertBefore(wrapper, div1);

        wrapper.appendChild(outerWrapper);

        outerWrapper.appendChild(div1);
        outerWrapper.appendChild(div2);
        outerWrapper.appendChild(div3);

    //     let html = `
    // <div class="la-metafield-wrapper">
    //   <div class="la-metafield-inner-wrapper">
    //     <div class="la-item la-metafield-item">Free Tracked UK Delivery</div> 
    //     <div class="la-itemla-metafield-dot">·</div>
    //     <div class="la-item la-metafield-item">Fitted by Qualified Opticians</div>
    //     <div class="la-itemla-metafield-dot">·</div>
    //     <div class="la-item la-metafield-item" style="color: #ffd34e;">★ 30% Off Lenses · Code: LENSES30</div>
    //   </div>
    //   <div class="la-metafield-inner-wrapper la-mobile-wrapper">
    //     <div class="la-itemla-metafield-dot">·</div>
    //     <div class="la-item la-metafield-item">Free Tracked UK Delivery</div> 
    //     <div class="la-itemla-metafield-dot">·</div>
    //     <div class="la-item la-metafield-item">Fitted by Qualified Opticians</div>
    //     <div class="la-itemla-metafield-dot">·</div>
    //     <div class="la-item la-metafield-item" style="color: #ffd34e;">★ 30% Off Lenses · Code: LENSES30</div>
    //   </div>
    // </div>`;
    let ship_country_txt = "";
    let ship_txt = "";
    if (currentCountry=="US") {
      ship_country_txt = '<div class="la-item la-metafield-item">Free Shipping in the USA</div>';
    }
    else if(currentCountry == "GB"){
      ship_country_txt = '<div class="la-item la-metafield-item">Free Tracked UK Delivery</div>';
    }
    if(productVendor === 'chanel' || productVendor === 'cartier'){
     ship_txt = '<div class="la-item la-metafield-item chanel-cartier-pdp" style="color: #ffd34e;">★ FREE 1.5 ZEISS CLEAR DISTANCE & READING LENSES</div>';
    }else{
      ship_txt = '<div class="la-item la-metafield-item" style="color: #ffd34e;">★ 40% Off Lenses · Code: LENSESDEAL40</div>';
   
    }
      let html = `
    <div class="la-metafield-wrapper" data-cc="${currentCountry}">
      <div class="la-metafield-inner-wrapper">
        ${ship_txt}        
        ${ship_country_txt}
      </div>
    </div>
  <style>
@media (max-width: 767px) {
  .fe-flow-jtpl .la-metafield-wrapper .la-metafield-inner-wrapper {
    min-height: 20px;
    min-width:${window.outerWidth-10}px;
  }
}
</style>
  `;
    if(window.outerWidth < 768){
      console.log("Init slider----");
      
      setTimeout(() => {
  var elem = document.querySelector('.la-metafield-inner-wrapper');
  if (!elem) return;

  var flkty = new Flickity(elem, {
    cellAlign: 'center',
    contain: true,
    wrapAround: true,
    autoPlay: 5000,
    prevNextButtons: false,
    pageDots: false,
    draggable: true
  });

  // Force a layout recalculation once the flex parent has settled
  flkty.resize();
  requestAnimationFrame(() => flkty.resize());
}, 500);
    }
    document
      .getElementById('outer-wrapper')
      .insertAdjacentHTML('afterbegin', html);
      if(window.outerWidth >= 768){
      // const footer = document.getElementById("la-boxy-footer-modal");
      // const information = document.querySelector(".la-boxy-layout-modal-wrapper");
      //   information.appendChild(footer);

      // const footer = document.getElementById("la-boxy-footer-modal");
      // const information = document.querySelector(".la-subtotal-modal-trigger");
      //   information.before(footer);
      }

        document.querySelector(".la-footer-row.la-subtotal .la-footer-text.la-translate").textContent = "Total";

        const priceText = document.querySelector(".la-footer-row.la-subtotal .la-subtotal-price")?.textContent.trim();
      const price = priceText
        ?.replace(/[^\d.]/g, "")
        .replace(".", "");       

        
        const currencyCode = document.body.getAttribute('currency-code');
          const klarna =`
        <klarna-placement
           data-key="credit-promotion-badge"
           data-locale="en-${ currencyCode }"
           data-purchase-amount="${price}"
           data-message-preference="prequalification"
        ></klarna-placement> `
         document.querySelector(".la-footer-row.la-subtotal").insertAdjacentHTML('afterend', klarna);
        if(window.outerWidth <= 767){
          // console.log("yes",window.outerWidth);
          const klarna =`
          <div class="mobile-footer-wrapper"><klarna-placement
           data-key="credit-promotion-badge"
           data-locale="en-${ currencyCode }"
           data-purchase-amount="${price}"
           data-message-preference="prequalification"
        ></klarna-placement>
        <div class="mobile-summary-wrapper"><div class="mobile-footer-sum show-icon">Summary ▲</div><div class="mobile-footer-sum hide-icon">Hide ▼</div></div>
        </div>`
        const totaltext = `<div class="la-footer-total">Your Total</div>`
         document.querySelectorAll(".la-subtotal-price-wrapper")[0].insertAdjacentHTML('afterend', klarna);
         document.querySelectorAll(".la-subtotal-price-wrapper")[0].insertAdjacentHTML('afterbegin', totaltext);
          if(document.querySelectorAll(".la-subtotal-price-wrapper")[1]){
         document.querySelectorAll(".la-subtotal-price-wrapper")[1].insertAdjacentHTML('afterend', klarna);
         document.querySelectorAll(".la-subtotal-price-wrapper")[1].insertAdjacentHTML('afterbegin', totaltext);
            }
         
        }
         window.dispatchEvent(new Event('resize')); 
         window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
          window.KlarnaOnsiteService.push({
            eventName: 'refresh-placements'
          });
        }, 20);
        setTimeout(function(){
         window.dispatchEvent(new Event('resize')); 
         window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
          window.KlarnaOnsiteService.push({
            eventName: 'refresh-placements'
          });
         
         const klarnaElements = document.querySelectorAll("#wrapper-lensadvisor-jtpl klarna-placement");

        klarnaElements.forEach((klarnaElement) => {
          const shadowRoot = klarnaElement.shadowRoot;

          if (!shadowRoot) return;

          if (!shadowRoot.querySelector("#klarna-custom-style")) {
            const style = document.createElement("style");
            style.id = "klarna-custom-style";
            style.textContent = `
                  .container {
                    flex-direction: row-reverse !important;
                    background: transparent !important;
                    border: 0 !important;
                    padding: 0 !important;
                    justify-content: flex-end !important;
                    align-items: flex-end !important;
                    position: relative;
                  }
                  .container.order-summary-klarna{
                    justify-content: center !important;
                  }
                  .container button.link {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: auto;
                    font-size: 0;
                  }
                  .container .text-wrapper p.legal{
                    display:none !important;
                  }
                  .container .text-wrapper {
                    margin-left: 0;
                    color: #8a857d;
                    font-size: 12px;
                    line-height: normal;
                    margin-right: 3px;
                  }
                  .container .text-wrapper strong {
                    font-weight: normal;
                  }
                  .container .badge svg {
                    height: 18px;
                    width: 40px;
                    // transform: translateY(1px);
                  }
                  @media (max-width: 1140px) {
                    .container .text-wrapper {
                      font-size: 10px;
                    }
                  }
                  @media (max-width: 994px) {
                    .container .text-wrapper {
                      font-size: 8.5px;
                    }
                  }
                  @media (max-width: 767px) {
                   .desktop-klarna .container {
                      justify-content: center !important;
                    }
                    .container .text-wrapper {
                      font-size: 11px;
                    }
                  }
                `;

                klarnaElement.shadowRoot.appendChild(style);
            }
          });
           window.dispatchEvent(new Event('resize'));
           window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
            window.KlarnaOnsiteService.push({
            eventName: 'refresh-placements'
          });
        }, 25);

        if(window.outerWidth > 767){
        if(openPopup == false){
          setTimeout(function(){
            openPopup = true;
            document.getElementById("la-boxy-footer-modal").setAttribute("style", "display: flex !important");
            document.querySelector(".la-prescription-boxy-footer").setAttribute("style", "display: flex !important");
            document.querySelector(".la-prescription-modal-close").setAttribute("style", "display: flex !important");
          }, 700);
        }else{
          setTimeout(function(){
            document.getElementById("la-boxy-footer-modal").setAttribute("style", "display: flex !important");
            document.querySelector(".la-prescription-boxy-footer").setAttribute("style", "display: flex !important");
            document.querySelector(".la-prescription-modal-close").setAttribute("style", "display: flex !important");
          }, 10);
        }
      }
      
      setInterval(() => {
        const priceText = document
          .querySelector(".la-footer-row.la-subtotal .la-subtotal-price")
          ?.textContent.trim();

        const price = priceText
          ?.replace(/[^\d.]/g, "")
          .replace(".", "");

        const elements = document.querySelectorAll("[data-purchase-amount]");

          if (price) {
            elements.forEach((element) => {
              element.removeAttribute("data-purchase-amount");
              element.setAttribute("data-purchase-amount", price);
            });
          }
        }, 15);

});
//****************  Hightlight last selected item start ***************/

// Records every choice the customer makes in the widget (prescription type, submission
// method, lens group, lens, lens options, add-ons). When a step is re-rendered after
// pressing Back, the previously chosen card gets a highlight and a "Your previous choice" badge.
// The widget's own state resets on back navigation, so selections are tracked here.
document.addEventListener("DOMContentLoaded", function () {
LensAdvizor.prevSelectionBadgeText = "✓";
LensAdvizor.prevSelections = {};
// Work out which step (and sub-step) an input belongs to, so selections
// for one lens/step never leak onto another.
LensAdvizor.prevSelectionStepKey = function(input) {
    const response = LensAdvizor.response || {};
    if (input.closest('.la-render-addons')) {
        const lensId = response.lens && response.lens.id ? response.lens.id : 'flow';
        return 'addons:' + lensId + ':' + (response.addOnsStep || 0);
    }
    if (input.closest('.la-render-options')) {
        const lensId = response.lens && response.lens.id ? response.lens.id : '';
        return 'options:' + lensId + ':' + (input.dataset.optionType || input.name);
    }
    const lensesStep = input.closest('.la-render-lenses');
    if (lensesStep) {
        if (lensesStep.classList.contains('x-pro')) return 'lensGroup';
        const pt = response.selectedPrescriptionType;
        return 'lens:' + (pt ? pt.id : '');
    }
    if (input.closest('.la-label-btn-wrapper') && input.closest('.la-label-btn-wrapper').classList.contains('la-submission-method')) {
        return 'submissionMethod';
    }
    if ((LensAdvizor.prescriptionTypes || []).some(pt => String(pt.id) === String(input.value))) {
        return 'prescriptionType';
    }
    return null;
};
// Record selections as they happen (click covers taps on the card labels too,
// keydown covers Enter/Space selection).
LensAdvizor.prevSelectionCapture = function(e) {
    const input = e.target;
    if (!input || input.tagName !== 'INPUT' || input.disabled) return;
    if (input.type !== 'radio' && input.type !== 'checkbox') return;
    if (!input.closest('#lensadvizor-prescription-modal')) return;
    if (!input.closest('.la-label-btn-wrapper')) return;
    if (e.type === 'keydown' && !(LensAdvizor.clickKeycodes || ['Enter', 'Space']).includes(e.code)) return;
    const key = LensAdvizor.prevSelectionStepKey(input);
    if (!key) return;
    if (input.type === 'checkbox') {
        // Read the checkbox state on the next tick so it reflects the toggle
        setTimeout(function() {
            const list = LensAdvizor.prevSelections[key] || [];
            const idx = list.indexOf(input.value);
            if (input.checked && idx === -1) list.push(input.value);
            if (!input.checked && idx > -1) list.splice(idx, 1);
            LensAdvizor.prevSelections[key] = list;
        }, 0);
    } else {
        LensAdvizor.prevSelections[key] = [input.value];
    }
};
document.addEventListener('click', LensAdvizor.prevSelectionCapture, true);
document.addEventListener('keydown', LensAdvizor.prevSelectionCapture, true);
// Re-apply highlights whenever a step is (re)rendered. Skips inputs that are
// already checked - the current selection is styled via CSS on :checked instead.
LensAdvizor.prevSelectionApply = function() {
    const modal = document.querySelector('#lensadvizor-prescription-modal');
    if (!modal) return;
    modal.querySelectorAll('.la-label-btn-wrapper').forEach(function(wrapper) {
        const input = wrapper.querySelector('input[type="radio"], input[type="checkbox"]');
        let isPrevious = false;
        let isAddon;
        if (input && !input.disabled && !input.checked) {
            const key = LensAdvizor.prevSelectionStepKey(input);
            const list = key ? LensAdvizor.prevSelections[key] : null;
            isPrevious = !!(list && list.indexOf(input.value) > -1);
            isAddon = list;
        }
        
        wrapper.classList.toggle('la-prev-selected', isPrevious);
        const label = wrapper.querySelector('.la-label-btn');
        let badge = wrapper.querySelector('.la-prev-selected-badge');
        
        if (isPrevious && !badge && label) {
            badge = document.createElement('span');
            badge.className = 'la-prev-selected-badge';
            badge.textContent = LensAdvizor.Translation && LensAdvizor.Translation.getTranslatedText ?
                LensAdvizor.Translation.getTranslatedText(LensAdvizor.prevSelectionBadgeText) :
                LensAdvizor.prevSelectionBadgeText;
            label.appendChild(badge);
        } else if (!isPrevious && badge) {
            badge.remove();
        }

        const parentLabel = document.querySelector(".la-choose-prescription-wrapper");
        if (parentLabel && parentLabel.classList.contains("la-render-addons")) {
            document.querySelectorAll(".la-tap-select").forEach(function (addON) {

              var addOntrue = document.querySelector(".la-footer-frame-prescription.value8").getAttribute("addOn");
                const AddOnVal = addON.value;
                
                if (AddOnVal === addOntrue) {
                    // console.log(addON);

                    const parent = addON.closest(".la-label-btn-wrapper");
                    if (parent) {
                        parent.classList.add("la-prev-selected");
                    }
                }
            });
        }

    });
};
LensAdvizor.prevSelectionScheduled = false;
LensAdvizor.prevSelectionSchedule = function() {
    if (LensAdvizor.prevSelectionScheduled) return;
    LensAdvizor.prevSelectionScheduled = true;
    requestAnimationFrame(function() {
        LensAdvizor.prevSelectionScheduled = false;
        LensAdvizor.prevSelectionApply();
    });
};
// Every step fires component:DidMount after its DOM is in place
document.addEventListener('LensAdvizor:component:DidMount', LensAdvizor.prevSelectionSchedule);

// Grouped-lens layout: lens cards live inside collapsed accordions where their inputs
// are DISABLED and hidden, and expanding is a style change the observer below misses.
// On the lens step, expand the group holding the previously chosen lens, then re-apply.
LensAdvizor.prevSelectionExpandLensGroup = function() {
    const modal = document.querySelector('#lensadvizor-prescription-modal');
    const lensesStep = modal && modal.querySelector('.la-render-lenses');
    if (!lensesStep) return;
    const inputs = lensesStep.querySelectorAll('.la-tap-select');
    if (!inputs.length) return;
    const key = LensAdvizor.prevSelectionStepKey(inputs[0]);
    const list = key ? LensAdvizor.prevSelections[key] : null;
    if (list && list.length) {
        const input = Array.prototype.find.call(inputs, function(i) {
            return list.indexOf(i.value) > -1;
        });
        const wrapper = input && input.closest('.la-accordion-wrapper');
        if (wrapper) {
            const body = wrapper.querySelector('.la-accordion-body');
            if (body && body.offsetHeight === 0 && wrapper.firstElementChild) wrapper.firstElementChild.click();
        }
    }
    LensAdvizor.prevSelectionSchedule();
};

});

document.addEventListener('LensAdvizor:lens:rendered', function() {
    setTimeout(LensAdvizor.prevSelectionExpandLensGroup, 0);
});
// Safety net for re-renders that do not fire DidMount (for example add-on updates)
document.addEventListener('LensAdvizor:selectLensModal:open', function() {
    const contentBox = document.querySelector('.la-prescription-modal-content-body');
    if (!contentBox || contentBox._prevSelectionObserved) return;
    contentBox._prevSelectionObserved = true;
    new MutationObserver(LensAdvizor.prevSelectionSchedule).observe(contentBox, {
        childList: true,
        subtree: true
    });
    LensAdvizor.prevSelectionSchedule();
});
// Start fresh once the item has been added to the cart
document.addEventListener('LensAdvizor:addToCart:success', function() {
    LensAdvizor.prevSelections = {};
});
//*******************************  Hightlight last selected item end **********************************/


//****************************  Order Summary layout start ********************************/
document.addEventListener("LensAdvizor:review:rendered", function (e) {
  // console.log(e);
  const Ptitle = document.querySelector(
    ".la-footer-text.la-footer-frame-variant-title"
  ).textContent;

  const Pprice = document.querySelector(
    ".la-footer-row .la-frame-price"
  ).textContent.replace(/\s+/g, "");

  const summaryItems = document.querySelectorAll(
    ".summary-prescription-wrapper:not(.hide-prescription)"
  );
let pdValue;
  document.querySelectorAll('.la-label-description').forEach(function (desc) {
    const text = desc.innerHTML;

    // check PD is exits
    const match = text.match(/PD:\s*([^<]+)/i);

    if (match) {
        pdValue = match[1].trim();
    }
});

  let reviewHTML = `
    <div class="la-review-main-wrapper">

      <div class="la-review-inner">
        <div class="la-lens-details la-lens-wrapper frame-main-wrapper">
          <div class="la-lens-title">
            <strong>Frame</strong>
            <p class="la-label-description la-lens-option-text frame-title">${Ptitle}</p>
          </div>
          <div class="la-lens-price">
            <div class="la-lens-price-inner frame-price">
              <strong>${Pprice}</strong>
            </div>
          </div>
        </div>
      </div>
  `;

  summaryItems.forEach((item) => {
    const heading = item.querySelector(".summary-prescription-heading")?.textContent.trim() || "";
    const title = item.querySelector(".summary-prescription-title")?.innerHTML || "";
    const price = item
    .querySelector(".summary-prescription-title")
    ?.getAttribute("new-price") || "";

    const displayPrice = price.toLowerCase().includes("free") ? "Free" : price;

    reviewHTML += `
      <div class="la-review-inner">
        <div class="la-lens-details la-lens-wrapper">
          <div class="la-lens-title">
            <strong>${heading}</strong>
            <p class="la-label-description la-lens-option-text lens-options-title">
              ${title}
            </p>
          </div>
          <div class="la-lens-price">
            <div class="la-lens-price-inner">
              ${displayPrice}
            </div>
          </div>
        </div>
      </div>
    `;
  });

document.querySelectorAll('.la-label-description').forEach(function (item) {

    const text = item.innerHTML.replace(/<br\s*\/?>/gi, "\n");
    const odMatch = text.match(/OD Right:\s*([^\n]+)/i);
    const osMatch = text.match(/OS Left:\s*([^\n]+)/i);

    if (odMatch) {
        reviewHTML += `
        <div class="la-review-inner">
            <div class="la-lens-details la-lens-wrapper la-lens-manually">
                <div class="la-lens-title">
                    <strong>OD Right</strong>
                    <p class="la-label-description la-lens-option-text lens-options-manully">
                        ${odMatch[1].trim()}
                    </p>
                </div>
                <div class="la-lens-price">
                    <div class="la-lens-price-inner"></div>
                </div>
            </div>
        </div>`;
    }

    if (osMatch) {
        reviewHTML += `
        <div class="la-review-inner">
            <div class="la-lens-details la-lens-wrapper la-lens-manually">
                <div class="la-lens-title">
                    <strong>OS Left</strong>
                    <p class="la-label-description la-lens-option-text lens-options-manully">
                        ${osMatch[1].trim()}
                    </p>
                </div>
                <div class="la-lens-price">
                    <div class="la-lens-price-inner"></div>
                </div>
            </div>
        </div>`;
    }
});


if(pdValue != null){
  reviewHTML += `
      <div class="la-review-inner">
        <div class="la-lens-details la-lens-wrapper">
          <div class="la-lens-title">
            <strong>PD</strong>
            <p class="la-label-description la-lens-option-text lens-options-pd">${pdValue}</p>
          </div>
          <div class="la-lens-price">
            <div class="la-lens-price-inner">
            </div>
          </div>
        </div>
      </div>
    `;
}
document.querySelectorAll('.la-review-item').forEach(function (item) {
    const descriptions = item.querySelectorAll('.la-label-description');
    descriptions.forEach(function (description) {
        const text = description.textContent.trim();
        if (text.includes('Prescriptions over SPH')) {

            const priceSource = item.querySelector('.la-review-right.la-label-title');

            reviewHTML += `
            <div class="la-review-inner">
              <div class="la-lens-details la-lens-wrapper">
                <div class="la-lens-title">
                  <strong>Prescriptions SPH or CYL Charges</strong>
                  <p class="la-label-description la-lens-option-text lens-options-over-charges">${text}</p>
                </div>
                <div class="la-lens-price">
                  <div class="la-lens-price-inner lens-options-over-charges-prices">
                   ${priceSource.textContent.trim()}
                  </div>
                </div>
              </div>
            </div>
          `;
          document.querySelector(".la-footer-row.la-subtotal").insertAdjacentHTML(
          'beforebegin', `
          <div class="la-footer-row-wrapper prescriptions-overcharge">
              <h3 class="la-translate">Prescriptions SPH or CYL Charges</h3>
              <div class="la-footer-row la-footer-lens-wrapper">
                  <div class="la-footer-lens-price">${priceSource.textContent.trim()}</div>
              </div>
          </div>
                    `);
        }
    });
});

 var discount = false;
  if(discount == true){

    const discountMessage = `<p><strong>LENSES25 applied</strong> 25% off your lenses</p>`;
  const temp = document.createElement("div");
  temp.innerHTML = discountMessage;

  const boldText = temp.querySelector("strong")?.textContent.trim() || "";
  const description = temp.querySelector("p")?.textContent.replace(boldText, "").trim() || "";

  reviewHTML += `
      <div class="la-review-inner">
        <div class="la-lens-details la-lens-wrapper">
          <div class="la-lens-title">
            <strong>${boldText}</strong>
            <p class="la-label-description la-lens-option-text lens-options-title">
              ${description}
            </p>
          </div>
          <div class="la-lens-price">
            <div class="la-lens-price-inner lens-discount-price">
            </div>
          </div>
        </div>
      </div>
    `;
  }
    reviewHTML += `
      <div class="la-review-inner total-review">
        <div class="la-lens-total la-lens-wrapper">
          <div class="la-lens-title">
            <strong>Total</strong>
          </div>
          <div class="la-lens-price">
            <div class="la-lens-total-price">
             <strong></strong>
            </div>
          </div>
        </div>
      </div>
    `;

  reviewHTML += `</div>`;

  document
    .querySelector(".la-review-details-wrapper")
    .insertAdjacentHTML("afterend", reviewHTML);

    if(EnableDiscount == true){
        document.querySelectorAll('.old-price, .new-price').forEach(function(el) {
          el.textContent = el.textContent.replace(/[+-]/g, '');
        });
    } else{
      document.querySelectorAll('.la-lens-price-inner').forEach(function(el) {
          el.textContent = el.textContent.replace(/[+-]/g, '');
      });
    }
    
      setTimeout(function(){
          const parentLabel = document.querySelector(".la-subtotal-price").textContent;
            document.querySelector(".la-lens-total-price strong").textContent = `${parentLabel.replace(/\s+/g, "")}`;
      }, 400);

    const priceText = document.querySelector(".la-footer-row.la-subtotal .la-subtotal-price")?.textContent.trim();
      const price = priceText
        ?.replace(/[^\d.]/g, "")
        .replace(".", "");       

        
        const currencyCode = document.body.getAttribute('currency-code');
          const klarna =`
        <klarna-placement
           data-key="credit-promotion-badge"
           data-locale="en-${ currencyCode }"
           data-purchase-amount="${price}"
           class="total-summary-klarna"
           data-message-preference="prequalification"
        ></klarna-placement> `
         document.querySelector(".la-review-inner.total-review").insertAdjacentHTML('afterend', klarna);
        setInterval(function(){
         const klarnaElement = document.querySelector('klarna-placement.total-summary-klarna');
          if (klarnaElement?.shadowRoot) {
            const container = klarnaElement.shadowRoot.querySelector('.container');
            if (container) {
              container.classList.add('order-summary-klarna');
            }
          }
        }, 10);

});
//****************  Order Summary layout end ***************/

//************************************  Metaobject base lens hide start  *************************/
function lensHide() {
    document.querySelectorAll(".la-label-btn-wrapper .la-label-btn .la-label-price").forEach(function (element) {
    var price = element.textContent.trim();

    if (price === "---") {
        console.log("price --- found :)");

        var wrapper = element.closest(".la-label-btn-wrapper");

        if (wrapper) {
          console('set1');
            wrapper.style.display = "none";

            setTimeout(function () {
                wrapper.style.display = "none";
                console('set2');
            }, 10);

            setTimeout(function () {
              console('set3');
                wrapper.style.display = "none";
            }, 500);
        }
    }
});

  //*******************  Product Details start  ****************//
  const producttags = document.querySelector(".product-details-lensadvisor .data-tags")
  ?.textContent.toLowerCase()
  .split(",")
  .map(t => t.trim())
  .filter(Boolean) || [];

const productvendor = document.querySelector(".product-details-lensadvisor .data-vendor")
  ?.textContent.toLowerCase()
  .split(",")
  .map(t => t.trim())
  .filter(Boolean) || [];

const producttype = document.querySelector(".product-details-lensadvisor .data-type")
  ?.textContent.toLowerCase()
  .split(",")
  .map(t => t.trim())
  .filter(Boolean) || [];

const productmarket = document.querySelector(".product-details-lensadvisor .data-market")
  ?.textContent.toLowerCase()
  .split(",")
  .map(t => t.trim())
  .filter(Boolean) || [];
  //*******************  Product Details end  ****************//


  //*******************  Metaobject Data Build ****************//
 const metaData = [];

document.querySelectorAll(".metaobject-lens-lensadvisor .meta-item").forEach((item) => {
  const lensname = item
    .querySelector(".lens-name")
    ?.textContent.toLowerCase()
    .split(",")
    .map(t => t.trim())
    .filter(Boolean) || [];

  const metatag = item
    .querySelector(".hide-tags")
    ?.textContent.toLowerCase()
    .split(",")
    .map(t => t.trim())
    .filter(Boolean) || [];

  const metavendor = item
    .querySelector(".hide-vendor")
    ?.textContent.toLowerCase()
    .split(",")
    .map(t => t.trim())
    .filter(Boolean) || [];

  const metatype = item
    .querySelector(".hide-type")
    ?.textContent.toLowerCase()
    .split(",")
    .map(t => t.trim())
    .filter(Boolean) || [];

  const marketName = item
    .querySelector(".market-name")
    ?.textContent.toLowerCase()
    .split(",")
    .map(t => t.trim())
    .filter(Boolean) || [];

  const hideLensName = item
    .querySelector(".hide-lens-name")
    ?.textContent.toLowerCase()
    .split(",")
    .map(t => t.trim())
    .filter(Boolean) || [];  

  const showLensName = item
    .querySelector(".show-lens-name")
    ?.textContent.toLowerCase()
    .split(",")
    .map(t => t.trim())
    .filter(Boolean) || [];
      
  metaData.push({
    lensname,
    metatag,
    metavendor,
    metatype,
    marketName,
    hideLensName,
    showLensName
  });
});
  // console.log("Meta Data:", metaData);
  //*******************  Matching Logic ****************//
    const elementss = document.querySelectorAll(".la-label-title, .la-lensgroup-title");
  document.querySelectorAll(".la-label-title, .la-lensgroup-title").forEach((el) => {
    if (elementss.length > 3) {
      let text = el.textContent.toLowerCase().trim();

      metaData.forEach((meta) => {
        let ProductTags = producttags.some((tag) => meta.metatag.includes(tag));
        let ProductVendor = productvendor.some((vendor) => meta.metavendor.includes(vendor));
        let ProductType = producttype.some((type) => meta.metatype.includes(type));
        let MarketName = productmarket.some(market =>meta.marketName.some(m => m.toLowerCase() === market.toLowerCase()));

        // console.log(MarketName);

        if (ProductTags || ProductVendor || ProductType) {
          meta.lensname.forEach((name) => {
            if (text == name) {
              let wrapper = el.closest(".la-label-btn-wrapper");

              if (wrapper) {
                console.log('1')
                wrapper.style.display = "none";
              }

              const interval = setInterval(() => {
                let wrapper = el.closest(".la-label-btn-wrapper");

                if (wrapper) {
                  console.log(name);
                  console.log('2')
                  wrapper.style.display = "none";
                  clearInterval(interval);
                }
              }, 50);
            }
          });

          if(MarketName){
              meta.hideLensName.forEach((name) => {
                if (text.includes(name)) {
                  let wrapper = el.closest(".la-label-btn-wrapper");

                  if (wrapper) {
                    wrapper.style.display = "none";
                  }

                  const interval = setInterval(() => {
                    let wrapper = el.closest(".la-label-btn-wrapper");

                    if (wrapper) {
                      wrapper.style.display = "none";
                      clearInterval(interval);
                    }
                  }, 50);
                }
              });

              meta.showLensName.forEach((name) => {
                if (text.includes(name)) {
                  let wrapper = el.closest(".la-label-btn-wrapper");
                  
                  if (wrapper) {
                    wrapper.style.display = "block";
                  }

                  const interval = setInterval(() => {
                    let wrapper = el.closest(".la-label-btn-wrapper");

                    if (wrapper) {
                      wrapper.style.display = "block";
                      clearInterval(interval);
                    }
                  }, 50);
                }
              });
            }

          }
        
      });
    }
  });

}

  document.addEventListener('LensAdvizor:init:complete', function(){
    // console.log("loaded===done");
    lensHide();
  });
  document.addEventListener('LensAdvizor:init:start', function() {
    lensHide();
  });
  document.addEventListener('LensAdvizor:lens:rendered', function() {
    lensHide();
  });
  document.addEventListener('LensAdvizor:component:DidMount', function (evt) {
    lensHide();
  });

  document.addEventListener('LensAdvizor:lensOptions:rendered', lensHide);
  document.addEventListener('LensAdvizor:lensOption1:rendered', lensHide);
  document.addEventListener('LensAdvizor:lensOption2:rendered', lensHide);
  document.addEventListener('LensAdvizor:lensOption3:rendered', lensHide);
  document.addEventListener('LensAdvizor:lensVariant:change', lensHide);
  document.addEventListener('LensAdvizor:component:DidMount', function (evt) {
    lensHide();
  });
//************************************  Metaobject base lens hide end  *************************/

}

document.addEventListener('DOMContentLoaded', function () {
  function wireTrigger(triggerSelector, placementSelector, ctaPartSelector) {
    var trigger = document.querySelector(triggerSelector);
    var placement = document.querySelector(placementSelector);

    if (!trigger || !placement) return;

    trigger.style.cursor = 'pointer';

    trigger.addEventListener('click', function () {
      var root = placement.shadowRoot;
      if (!root) return;
      var cta = root.querySelector(ctaPartSelector) || root.querySelector('button');
      if (cta) cta.click();
    });
  }

  wireTrigger('.payment-image-one', 'klarna-placement', '[part="osm-cta"]');
  wireTrigger('.payment-image-two', 'square-placement', '[part="logo-link"]');
});